// AUTO-GENERATED from current OpenStreetMap Singapore rail route relations.
// Each line contains every unique member way, including branches and terminal segments.

export const CURRENT_MRT_PATHS: Record<string, string[]> = {
  "nsl": [
    "M542.8 406.8L535.9 411.3L535.4 411.7L533.1 413.2L531.5 414.3",
    "M531.5 414.3L530.8 414.8L530.7 414.8L530.3 415.0L529.2 415.2L528.4 415.3L528.0 415.3L527.5 415.2L527.2 415.1L526.7 415.0L526.3 414.9L525.8 414.7L525.4 414.6L524.9 414.3L518.3 409.4L517.4 408.3L516.9 407.5L516.6 406.9L516.3 406.3L516.1 405.6L515.8 404.3L515.0 400.2L514.7 399.3L514.5 398.6L513.9 397.6L512.7 395.6L511.5 393.7L510.0 391.1L509.8 390.6",
    "M509.8 390.6L509.6 389.9L509.5 389.4L509.4 388.8",
    "M509.4 388.8L509.6 386.3L509.7 385.7L509.8 384.1L509.9 382.9L510.3 381.5L511.5 378.4",
    "M511.5 378.4L512.8 376.1L513.3 374.6L513.4 373.2L513.3 372.2L512.9 371.2",
    "M512.9 371.2L512.5 370.3L511.5 368.7L511.0 367.8L510.0 366.4",
    "M510.0 366.4L508.6 364.5L506.5 361.8L505.4 360.3L504.0 359.2L502.1 358.0L500.1 357.3L498.1 356.6L496.6 356.1L495.5 355.8L494.4 355.6L487.2 354.3L483.5 353.4L479.8 352.5L478.6 352.4L476.4 352.7L475.0 352.9L473.7 352.7L472.5 352.3L471.5 351.7L470.6 350.8L470.1 350.1L469.6 348.9L469.3 347.6L469.2 345.9L469.1 344.2L469.1 343.3L469.2 342.5L469.5 341.7L472.1 336.0L473.6 333.7L475.6 332.0L481.0 328.2L482.5 327.2L486.5 324.2L488.3 319.4L489.1 316.9L489.3 316.2L489.4 316.1L492.7 312.2L493.5 311.4L494.6 310.1L496.0 308.6L497.0 307.3L497.9 305.7L498.7 303.9L499.3 301.9L500.2 296.9L501.6 293.1L501.9 291.6L501.9 290.1L501.6 288.3L501.3 286.9L500.8 285.0L500.6 283.7L500.1 282.3L499.0 280.1L498.2 278.1L498.1 276.6L498.3 275.2L499.2 273.1L499.4 272.2L499.5 269.8L499.5 268.5L499.6 261.3L501.3 253.0",
    "M501.3 253.0L501.4 252.4L501.6 251.7L501.8 250.4L501.9 250.1",
    "M501.9 250.1L502.1 249.0",
    "M502.1 249.0L502.4 248.0",
    "M502.4 248.0L502.6 247.2L502.6 246.8L502.7 246.7",
    "M502.7 246.7L503.0 245.1L503.4 243.5L503.4 243.4",
    "M503.4 243.4L503.6 242.6",
    "M503.6 242.6L503.8 242.2L504.0 241.6L504.3 241.2L504.5 240.7",
    "M504.5 240.7L505.7 238.6L506.2 237.7L506.8 236.8L507.2 236.0L507.7 235.3L508.1 234.6L508.5 234.0L509.1 233.1L509.6 232.2L509.9 231.7L510.4 230.8L511.2 229.7L511.6 228.9L511.9 228.3L512.2 227.7L512.4 227.2L512.6 226.7L512.7 226.2L512.8 225.7L512.8 225.2L512.9 224.6L512.9 224.1L512.8 223.4L512.6 222.8L512.5 222.2L512.2 221.5L511.9 220.8L508.4 214.7L507.9 213.8L507.4 213.0L506.3 211.1L505.8 210.1L505.1 208.8L504.4 207.6L504.0 207.0L503.8 206.6L503.6 206.1L503.5 205.7L503.4 205.4L503.3 205.0L503.1 203.3L503.0 202.8L502.8 200.9L502.4 197.8L502.2 196.6L501.8 193.3L501.4 191.6L500.9 190.6L500.5 189.8L499.8 188.9L499.2 188.1L498.2 187.1L497.3 186.1L497.0 185.9L495.7 184.5L494.1 182.9L493.5 182.0L493.2 181.4L492.8 180.7L492.6 180.1L491.7 177.9L490.6 175.0L489.8 173.0L489.1 171.1L488.6 170.1L488.4 169.5L488.1 168.9L487.7 168.3L487.2 167.7L486.6 167.0L486.0 166.4L485.3 165.8L484.5 165.2L481.6 163.4L477.3 160.7",
    "M477.3 160.7L469.6 155.8",
    "M469.6 155.8L468.3 155.0",
    "M468.3 155.0L467.3 154.3L466.2 153.5L465.0 152.4L464.5 151.8L464.0 151.2L463.3 150.2L462.6 149.2L461.8 147.7L461.3 146.5L460.7 144.7L460.3 142.9L460.2 141.9",
    "M460.2 141.9L460.1 141.5L460.1 141.0L460.1 139.6L460.2 139.0L460.2 138.4L460.3 137.5L460.5 136.6L460.7 135.9L460.9 135.2L461.1 134.6L461.5 133.9L462.3 132.0L462.5 131.5L462.7 130.9L462.8 130.4L462.9 129.8L462.9 129.2L463.0 128.6L463.0 127.4L463.0 126.9L463.0 126.4L463.1 126.0L463.2 125.3L463.4 124.8L463.6 124.2L464.0 123.5L464.6 122.6L465.3 121.7L466.0 120.7L466.5 119.9L467.2 118.7L467.8 117.4L468.3 116.4L469.1 114.8L469.4 114.1L469.7 113.1L470.4 111.9L471.0 110.6L471.6 109.4L472.1 108.4L472.5 107.6L473.2 106.5L473.8 105.4L474.1 104.6L474.3 103.9L474.4 103.2L474.5 102.4L474.6 100.9L474.7 99.4L474.9 94.3L474.9 94.3L475.2 90.2L475.2 89.8L475.1 88.8L475.0 88.0L475.1 87.0L475.1 85.8L475.2 84.3L475.2 83.0L475.3 82.0L475.3 81.3L475.2 80.7L475.1 80.0L474.4 77.5L473.7 74.4L473.5 73.7L473.3 73.1L473.0 72.3L472.6 71.5L471.8 70.2L471.4 69.4L471.2 69.1L470.1 67.2L468.9 65.1L466.1 60.6L463.9 57.1L463.0 55.4L461.0 52.2L460.5 51.4L460.0 50.6L459.3 49.8L458.8 49.3L458.4 48.8L457.7 48.2L456.8 47.4L456.3 46.9L455.8 46.4L455.1 45.9L454.1 45.3L453.6 45.0L453.0 44.7L451.9 44.4L451.1 44.2L450.4 44.1L449.3 44.1L448.4 44.1L447.9 44.2L447.2 44.4L446.1 44.6L445.8 44.7L444.3 45.1L442.8 45.4L442.2 45.5L441.7 45.6L439.5 46.0L437.4 46.5L435.4 47.0L429.6 48.3L425.9 49.2L425.0 49.5L424.2 49.8L423.0 50.4L422.1 50.9L421.3 51.5L420.0 52.6L419.1 53.6L418.4 54.4L417.5 55.2L416.6 56.0L415.8 56.8L415.3 57.2L414.8 57.6L414.1 58.1L413.3 58.5L411.2 59.5L409.1 60.5L408.0 61.1L407.3 61.5L406.2 62.0L404.7 62.6L403.3 63.3L402.4 63.7L401.3 64.1L400.0 64.5L399.3 64.9L398.3 65.3L397.4 65.6L396.6 65.8L395.7 65.9L394.6 65.9L386.8 66.3L385.8 66.4L385.0 66.5L384.1 66.7L383.3 67.0L382.3 67.3L379.4 68.4L376.3 69.6",
    "M376.3 69.6L374.6 70.2L373.3 70.7",
    "M373.3 70.7L372.8 70.9L371.1 71.5L370.5 71.8L369.8 72.0L369.4 72.2L368.9 72.4L368.5 72.6L368.2 72.8L367.9 73.0L367.5 73.3L367.1 73.6L366.7 74.0L366.4 74.3L366.2 74.5L365.9 74.8L365.3 75.4L364.7 75.9L364.1 76.5L363.6 76.9L363.3 77.2L362.8 77.5L362.4 77.8L362.0 78.0L361.6 78.3L361.2 78.5L360.8 78.7L360.2 78.9L359.7 79.0L359.2 79.1L358.7 79.2L358.3 79.3L357.7 79.4L357.1 79.4L354.1 79.4L350.6 79.4L349.0 79.4L347.5 79.4L346.0 79.3L344.9 79.3L344.0 79.4L339.7 80.4L338.8 80.7",
    "M338.8 80.7L338.5 80.8L337.8 81.1L337.1 81.4L336.7 81.7L336.2 82.1L335.6 82.6L335.1 83.1L334.6 83.6",
    "M334.6 83.6L334.0 84.5L333.0 86.2",
    "M333.0 86.2L332.9 86.5",
    "M332.9 86.5L331.1 89.2",
    "M331.1 89.2L330.7 89.6L330.3 89.9L329.5 90.6L328.4 91.3",
    "M328.4 91.3L327.9 91.7L326.0 93.2L325.3 93.7L324.0 94.6L322.8 95.4L321.9 96.0L321.3 96.4L320.5 96.8L319.9 97.0L318.4 97.6L317.4 98.0L316.3 98.3L315.2 98.6L313.5 99.0L312.0 99.3L308.3 100.1L303.4 101.1L302.6 101.3L302.0 101.6L301.4 101.8L300.5 102.3L299.9 102.7L299.3 103.0L298.7 103.6L298.2 104.1L297.6 104.7L297.3 105.2L296.7 106.1L296.2 107.1L295.9 108.1L295.6 109.0L295.4 110.1L295.4 111.0L295.4 111.9L295.5 112.9L296.1 116.5L296.5 118.9L296.6 118.9L296.9 120.9L298.4 129.3L298.5 129.9L298.6 130.7L298.6 131.4L298.7 132.0L298.7 132.9L298.6 133.7L298.4 134.6L298.2 135.7L298.0 136.7L297.3 139.4L296.5 142.4L295.7 145.1L295.0 147.6L294.5 149.4L294.3 150.4L293.8 152.0L293.5 153.3L293.3 154.1L293.0 154.8L292.8 155.5L292.1 156.8L291.2 158.2L290.0 160.0L289.2 161.3L288.6 162.3L288.1 163.3L287.6 164.4L287.2 165.8L287.0 166.6L286.9 167.4L286.9 168.2L286.9 169.1L287.1 173.0L287.3 174.3L287.3 175.4L287.4 177.1L287.5 178.8L287.5 179.3L287.6 180.3L287.5 180.9L287.4 181.7L287.2 182.5L287.1 183.4L286.5 186.6L286.0 189.5L285.8 190.7L285.7 191.5L285.7 192.0L285.7 192.7L285.7 193.3",
    "M285.7 193.3L285.8 194.0L285.9 194.9L286.0 195.4",
    "M286.0 195.4L286.1 196.0",
    "M286.1 196.0L286.2 196.6L286.4 197.6L286.8 198.8L287.0 199.5L287.4 200.5L287.8 201.3",
    "M287.8 201.3L288.3 202.2L289.0 203.3L290.0 204.6L290.8 205.5L292.0 206.6L294.9 209.2L296.6 210.7L297.9 211.9L299.2 213.0L300.3 214.0L301.1 215.0L301.6 216.1L301.9 216.8L302.1 217.6L302.2 218.5L302.3 219.4L302.4 221.8L302.5 225.5L302.6 227.3L302.9 229.4L302.9 230.5L303.0 231.9L303.0 233.2L303.0 233.9L303.0 235.8L303.1 237.8",
    "M303.1 237.8L303.1 239.2L303.2 240.4L303.3 242.6L303.2 243.6L303.2 243.9L303.1 244.2",
    "M303.1 244.2L303.0 244.7",
    "M303.0 244.7L302.9 245.2L302.8 245.7L302.6 246.1L302.3 246.6L302.0 247.1",
    "M302.0 247.1L301.9 247.3L301.7 247.6L301.6 247.7L301.4 248.0",
    "M301.4 248.0L300.7 248.9L300.3 249.5L299.9 250.2L299.4 250.9L299.1 251.3L298.3 252.3L297.4 253.6L296.8 254.4L296.2 255.1L295.4 256.0L294.0 258.0L293.0 259.3L292.1 260.5L289.0 264.6L286.4 268.1L284.9 270.0L282.5 273.4L281.7 274.3L281.3 274.8L281.0 275.4L280.8 275.6L280.7 275.9L280.5 276.2L280.4 276.6L280.3 276.9L280.2 277.2L280.1 277.6L280.1 277.9L280.1 278.2L280.0 278.6L280.1 279.0L280.1 279.3L280.2 279.7L280.3 280.1L280.4 280.4L280.5 280.7L280.6 281.0L280.8 281.3L281.1 281.8L281.4 282.4L281.7 283.0L281.9 283.4",
    "M281.9 283.4L283.0 285.4L283.7 286.7",
    "M281.9 283.4L281.0 281.8L280.7 281.3L280.5 281.0L280.4 280.7L280.3 280.3L280.1 279.9L280.0 279.5L280.0 279.1L280.0 278.7L280.0 278.3L280.0 277.9L280.0 277.6L280.1 277.3L280.2 276.8L280.3 276.5L280.4 276.2L280.6 275.8L280.7 275.6L280.9 275.3L281.1 275.1L281.8 274.1L282.4 273.3",
    "M282.4 273.3L285.1 269.6L285.9 268.5",
    "M285.9 268.5L286.3 268.0L288.9 264.5L292.0 260.5L292.9 259.2L293.9 257.9L295.3 255.9L296.0 255.0L296.5 254.2L297.1 253.5L298.1 252.2L298.9 251.1L299.1 250.7L299.7 250.1L300.2 249.4L300.6 248.9L301.4 247.9",
    "M301.4 247.9L301.6 247.6L301.8 247.2L302.0 247.0",
    "M302.0 247.0L302.2 246.6L302.5 246.0L302.7 245.6L302.8 245.2L302.9 244.7",
    "M302.9 244.7L303.0 244.2",
    "M303.0 244.2L303.1 243.9L303.1 243.5L303.2 242.6L303.1 240.4L303.1 239.8L303.0 237.1",
    "M303.0 237.1L302.9 235.8L302.8 234.2L302.7 233.4L302.7 231.9L302.6 230.5L302.5 227.3L302.4 225.5L302.3 221.8L302.2 219.4L302.1 218.5L302.0 217.6L301.8 216.9L301.6 216.2L301.0 215.0L300.2 214.1L299.2 213.1L297.9 211.9L296.5 210.8L294.8 209.3L291.9 206.7L290.7 205.6L290.0 204.7L288.9 203.3L288.2 202.2L287.7 201.4",
    "M287.7 201.4L287.3 200.5L286.9 199.5L286.7 198.8L286.3 197.6L286.1 196.6L286.0 196.0",
    "M286.0 196.0L285.9 195.4",
    "M285.9 195.4L285.8 194.9L285.7 194.0L285.6 193.3",
    "M285.6 193.3L285.6 192.7L285.6 192.0L285.6 191.5L285.7 190.7L285.9 189.5L286.4 186.6L287.0 183.3L287.1 182.5L287.2 181.7L287.3 180.9L287.3 180.3L287.2 178.8L287.1 177.1L287.1 175.4L287.0 174.4L287.0 173.0L286.8 169.1L286.8 168.2L286.8 167.4L287.0 166.6L287.1 165.8L287.5 164.4L288.0 163.3L288.5 162.2L289.1 161.2L289.9 159.9L291.1 158.1L292.0 156.7L292.6 155.5L292.8 154.8L293.0 154.0L293.2 153.3L293.5 151.9L293.9 150.3L294.4 148.7L294.9 147.6L295.2 146.7L295.6 145.0L296.4 142.4L297.2 139.3L297.9 136.7L298.1 135.7L298.3 134.6L298.5 133.7L298.6 132.8L298.5 132.0L298.5 131.4L298.5 130.7L298.4 129.9L298.3 129.3L296.8 120.9L296.4 118.9L296.0 116.5L295.4 112.9L295.3 111.9L295.3 111.0L295.3 110.1L295.5 109.0L295.8 108.0L296.2 107.0L296.6 106.1L297.2 105.2L297.6 104.7L298.1 104.1L298.7 103.5L299.3 103.0L299.8 102.6L300.4 102.2L301.3 101.7L301.9 101.5L302.6 101.2L303.4 101.0L308.3 100.0L311.9 99.2L313.5 98.9L315.1 98.5L316.3 98.2L318.0 97.6L318.4 97.5L319.8 96.9L320.5 96.6L321.1 96.2L322.6 95.2L323.8 94.3L325.1 93.4L328.4 91.2",
    "M328.4 91.2L329.4 90.5L330.3 89.8L330.6 89.5L331.0 89.1",
    "M332.8 86.5L331.0 89.1",
    "M332.8 86.5L333.0 86.2",
    "M333.0 86.2L333.9 84.5L334.5 83.6",
    "M334.5 83.6L335.0 83.0L335.5 82.5L336.2 82.0L336.7 81.6L337.1 81.4L337.8 81.0L338.5 80.7L338.8 80.6",
    "M338.8 80.6L339.6 80.3L344.0 79.3L344.9 79.1L345.9 79.0L347.5 79.0L349.0 79.0L350.6 79.0L351.7 79.1L353.0 79.2L353.2 79.2L354.2 79.3L357.0 79.3L357.7 79.3L358.2 79.3L358.7 79.2L359.3 79.1L359.7 78.9L360.2 78.8L360.6 78.6L361.0 78.4L361.5 78.2L361.9 78.0L362.3 77.7L362.7 77.5L363.0 77.2L363.4 76.9L363.8 76.5L364.6 75.8L364.7 75.6L365.5 74.9L366.0 74.4L366.5 73.9L367.0 73.5L367.3 73.2L367.6 72.9L367.9 72.7L368.3 72.4L368.7 72.2L369.1 71.9L369.5 71.7L370.1 71.5L370.5 71.4L372.7 70.5",
    "M372.7 70.5L373.2 70.4L374.5 69.9L375.6 69.5L376.8 69.0",
    "M376.8 69.0L377.9 68.6L378.4 68.5L378.9 68.3L380.1 68.0L380.5 67.9L381.0 67.7L382.2 67.3L383.2 66.9L384.1 66.6L385.0 66.5L385.8 66.3L386.8 66.3L394.6 65.9L395.7 65.8L396.6 65.7L397.3 65.5L398.3 65.2L399.2 64.8L400.0 64.4L403.2 62.9L404.6 62.3L406.0 61.7L409.1 60.4L411.2 59.4L413.2 58.4L414.0 58.0L414.8 57.5L415.2 57.1L415.7 56.7L416.5 56.0L417.4 55.1L418.3 54.3L419.0 53.6L420.0 52.5L421.3 51.4L422.1 50.8L422.9 50.3L424.2 49.7L425.0 49.4L425.9 49.1L429.5 48.2L435.2 46.9L440.4 45.7L441.0 45.5L442.2 45.2L442.7 45.1L444.2 44.8L445.7 44.4L446.5 44.3L447.1 44.2L447.9 44.1L448.5 44.0L449.3 44.0L450.4 44.0L451.1 44.1L451.9 44.3L453.0 44.6L453.6 44.9L454.2 45.2L455.1 45.8L455.8 46.4L456.3 46.8L456.8 47.3L458.4 48.7L458.9 49.2L459.4 49.7L460.0 50.6L460.5 51.3L461.0 52.1L461.9 53.5L462.8 54.9L464.0 57.0L466.2 60.6L469.0 65.1L470.3 67.1L471.3 69.0L471.5 69.3L472.7 71.4L473.1 72.2L473.4 73.0L473.6 73.7L473.8 74.4L474.2 76.0L474.6 77.5L475.2 80.0L475.3 80.6L475.4 81.3L475.5 82.0L475.5 83.0L475.5 84.3L475.4 85.8L475.4 87.0L475.3 88.0L475.3 88.9L475.3 89.8L475.0 94.3L474.8 99.4L474.7 100.9L474.6 102.4L474.6 103.2L474.4 103.9L474.2 104.6L473.9 105.5L473.2 106.7L472.8 107.6L471.9 109.5L471.3 110.7L470.6 112.0L470.0 113.3L469.6 114.1L468.4 116.4L467.3 118.7L466.6 120.0L466.1 120.7L465.4 121.7L464.7 122.7L464.1 123.5L463.8 124.2L463.5 124.8L463.3 125.3L463.2 126.0L463.1 126.4L463.1 126.9L463.1 127.4L463.0 128.6L463.0 129.2L463.0 129.8L462.9 130.4L462.8 130.9L462.6 131.5L462.4 132.0L461.6 133.9L461.2 134.7L461.0 135.2L460.8 135.9L460.6 136.6L460.4 137.5L460.3 138.4L460.3 139.0L460.3 139.6L460.2 141.0L460.2 141.5L460.3 141.9",
    "M460.3 141.9L460.4 142.9L460.8 144.7L461.4 146.5L461.9 147.7L462.7 149.1L463.4 150.2L464.1 151.1L464.6 151.7L465.1 152.3L466.3 153.4L467.3 154.2L468.4 154.9",
    "M468.4 154.9L469.6 155.7",
    "M469.6 155.7L477.4 160.6",
    "M477.4 160.6L481.7 163.3L484.6 165.1L485.3 165.7L486.0 166.3L486.7 166.9L487.3 167.6L487.7 168.2L488.1 168.9L488.4 169.4L488.7 170.0L489.2 171.1L489.9 172.9L490.7 175.0L491.8 177.9L492.7 180.0L493.0 180.6L493.3 181.2L493.8 182.0L494.5 182.8L495.9 184.3L497.4 185.8L499.2 187.7L499.3 187.8L500.1 188.7L500.9 190.0L501.2 190.6L501.5 191.3L501.7 191.9L501.9 193.0L502.1 193.8L502.5 197.0L503.0 201.1L503.2 202.5L503.3 203.4L503.4 203.9L503.5 204.4L503.6 204.8L503.7 205.1L503.8 205.4L504.1 205.9L504.3 206.4L505.3 208.2L505.5 208.6L505.9 209.3L506.5 210.3L506.6 210.5L506.8 210.8L506.9 211.1L507.1 211.7L507.4 212.4L507.5 212.7L507.6 212.9L507.8 213.3L508.2 214.0L508.6 214.8L511.9 220.5L512.2 221.1L512.4 221.7L512.6 222.0L512.7 222.3L512.8 222.7L512.9 223.1L513.0 223.6L513.0 224.3L513.0 224.9L513.0 225.5L512.9 226.1L512.8 226.6L512.7 226.9L512.5 227.6L512.2 228.1L511.9 228.9L511.5 229.7L511.1 230.4L510.8 231.2L510.4 232.0L510.1 232.6L509.9 233.0L509.7 233.4L509.3 234.0L508.8 234.7L508.5 235.1L508.1 235.6L507.7 236.1L507.2 236.7L506.9 237.1L506.5 237.6L506.3 237.9L506.0 238.4L505.5 239.4",
    "M505.5 239.4L505.2 239.9",
    "M505.2 239.9L504.7 240.8",
    "M504.7 240.8L504.4 241.3L504.2 241.6L504.1 241.9L504.0 242.2L503.9 242.5L503.9 242.6",
    "M503.9 242.6L503.6 243.5",
    "M503.6 243.5L503.2 245.4L502.9 246.7L502.8 247.3L502.6 248.1",
    "M502.6 248.1L502.4 249.1",
    "M502.4 249.1L502.1 250.4L501.7 252.0L501.4 253.1",
    "M501.4 253.1L501.2 253.8L499.8 261.3L499.7 268.5L499.7 269.8L499.6 272.2L499.4 273.1L498.4 275.3L498.2 276.8L498.3 278.0L499.2 280.2L500.2 282.3L500.9 283.9L501.1 285.0L501.5 286.8L501.9 288.3L502.2 289.8L502.2 291.4L501.8 293.0L500.5 296.9L499.5 302.0L498.9 304.0L498.1 305.8L497.2 307.5L496.2 308.8L494.8 310.3L493.7 311.5L492.9 312.3L490.3 315.4L489.5 316.3L488.5 319.5L486.7 324.3L482.6 327.4L481.2 328.4L475.8 332.2L473.8 333.8L472.3 336.0L469.7 341.9L469.4 343.2L469.4 344.3L469.5 345.9L469.6 347.5L469.9 348.9L470.3 349.7L471.0 350.7L471.6 351.3L472.7 352.0L473.8 352.4L475.1 352.6L476.4 352.4L478.6 352.1L479.9 352.2L483.5 353.2L486.9 353.9",
    "M486.9 353.9L495.3 355.5L496.6 355.9L498.1 356.4L500.2 357.0L502.5 357.9L502.6 357.9L504.2 358.9L505.6 360.1L506.8 361.5L508.7 364.4L510.0 366.4",
    "M510.0 366.4L510.4 366.9L511.1 367.8L511.6 368.6L512.6 370.3L513.0 371.2",
    "M513.0 371.2L513.3 372.2L513.5 373.2L513.4 374.6L512.9 376.1L511.6 378.4",
    "M511.6 378.4L511.1 379.5L510.3 381.5L510.0 382.9L509.8 384.1L509.7 385.7L509.7 386.3L509.5 388.8",
    "M509.5 388.8L509.5 389.4L509.6 389.8L509.9 390.6",
    "M509.9 390.6L510.4 391.5L511.7 393.6L512.9 395.5L514.1 397.4L514.7 398.5L514.9 399.2L515.2 400.1L516.0 404.3L516.3 405.7L516.6 406.3L516.9 407.1L517.2 407.8L517.6 408.4L518.4 409.3L518.6 409.5L525.0 414.1L526.9 414.9L527.6 415.0L528.5 415.1L529.0 415.0L529.5 414.9L530.2 414.8L530.5 414.7L530.7 414.6L531.4 414.1",
    "M531.4 414.1L533.0 413.0L535.3 411.5L535.8 411.1L542.6 406.5"
  ],
  "ewl": [
    "M66.9 263.9L66.7 264.5L66.5 265.0L66.3 265.5L66.1 266.1L65.9 266.7L65.7 267.1L65.6 267.5",
    "M65.6 267.5L65.3 268.2L65.1 268.8",
    "M65.1 268.8L64.5 270.4L63.8 272.4L63.7 272.8",
    "M63.7 272.8L62.2 277.0L61.8 278.1L61.7 278.4L61.6 278.7L61.5 279.1L61.4 279.4L61.4 279.7L61.4 280.0L61.3 280.3L61.3 280.7L61.3 281.1L61.4 281.4L61.4 281.7L61.5 282.1L61.6 282.5L61.7 282.8L61.8 283.1L62.0 283.4L62.1 283.7L62.3 284.0L62.4 284.3L62.7 284.6L62.8 284.7L63.1 285.1L64.9 286.7L65.7 287.5L66.6 288.3L67.7 289.2L69.1 290.4L70.3 291.5L71.8 292.9L73.1 294.3L73.5 294.7L76.2 297.3L84.0 304.7L86.0 306.6L86.7 307.3L87.8 308.2L88.3 308.7L89.7 309.9L90.9 311.1L91.4 311.6L92.1 312.3L92.9 313.1L95.7 315.8L99.1 319.0L99.5 319.4L99.9 319.6L100.4 320.0L100.7 320.1L101.1 320.3L101.6 320.5L102.1 320.6L102.5 320.7L103.0 320.8L103.5 320.8L104.0 320.8L104.4 320.7L104.9 320.6L105.5 320.5L106.1 320.3L106.5 320.1L106.9 319.9L107.4 319.5L107.9 319.2L108.1 319.0L109.2 317.9L109.9 317.1L110.6 316.4L112.7 314.1L113.7 313.1L115.1 311.6L115.6 311.1L116.3 310.4L116.7 309.9L117.1 309.5L118.4 307.9L119.0 307.1L119.6 306.1L120.5 304.7L121.7 303.1L122.8 301.3L123.5 300.3L123.7 300.1L124.1 299.6L124.5 299.3L124.9 298.9L125.3 298.6L125.6 298.4L126.0 298.2L126.4 298.1L126.8 297.9L127.2 297.8L127.7 297.7L128.2 297.6L128.8 297.6L130.3 297.5L132.4 297.3L136.3 297.0L138.3 296.9L139.1 296.9L140.1 296.8L144.1 296.5",
    "M144.1 296.5L145.4 296.4L146.2 296.4L146.9 296.3L147.3 296.3L147.7 296.3L148.3 296.3L148.8 296.3",
    "M148.8 296.3L149.0 296.3L150.3 296.3L151.8 296.3L153.0 296.3L153.7 296.3L154.6 296.3L155.9 296.4",
    "M155.9 296.4L159.6 296.3L160.0 296.3L163.5 296.4L164.8 296.4L165.3 296.3L165.4 296.3L165.8 296.2L166.3 296.1L166.8 296.0L167.2 295.8L167.7 295.6L168.3 295.2L169.0 294.7L169.5 294.2L170.0 293.5L170.5 292.5L170.9 291.5L171.4 290.1L171.6 289.5L171.9 289.0L172.2 288.4L172.9 287.5L176.8 282.3L177.8 281.2L179.3 279.4L179.7 278.9L180.1 278.4L180.5 278.1L181.2 277.6L181.8 277.2L182.9 276.8L184.0 276.5L185.3 276.3L186.0 276.1L186.7 276.0L187.5 275.9L190.1 275.9L192.0 275.9L194.7 275.9L199.1 276.0L201.0 275.9L202.3 275.7L203.6 275.3L205.9 274.4L207.4 273.9L209.2 273.2L210.5 272.7L211.8 272.1L215.9 270.0L217.3 269.5L228.2 265.5L231.5 264.2L234.3 263.2L235.9 262.7L238.3 262.1L239.8 261.7L241.8 261.2L242.7 261.1L243.3 261.0L244.2 261.0L245.0 261.0L246.5 261.2L247.4 261.4L250.5 262.3L251.1 262.4L251.5 262.4L252.2 262.5L253.3 262.5L255.4 262.5L256.1 262.6L256.7 262.6L258.1 263.0L259.4 263.5L260.5 264.1L261.6 264.9L263.0 265.9L263.1 266.0L264.6 267.2L266.6 268.6L266.9 268.8L267.9 269.5L268.8 270.2L270.8 271.7L273.2 273.5L275.0 275.0L276.7 276.3L277.5 276.9L278.6 277.8L278.8 278.1L279.1 278.3",
    "M279.1 278.3L279.4 278.7L279.7 279.0L280.0 279.5L280.3 280.1L280.7 280.6",
    "M280.7 280.6L281.1 281.4L281.5 282.2L282.1 283.3L282.5 283.9L283.2 285.2L284.0 286.7L284.3 287.2L284.6 287.7L284.8 288.0L285.1 288.4L285.5 288.8L285.9 289.2L286.2 289.5L286.5 289.7L287.1 290.1L287.7 290.5L288.7 291.1L289.2 291.3L289.7 291.6L290.4 292.0L291.5 292.5L291.8 292.7L293.4 293.5L294.4 294.0L295.7 294.5L296.6 294.9L297.7 295.1L298.9 295.3L301.0 295.2L302.0 295.2L303.0 295.4L304.0 295.6L306.0 296.4L306.8 296.6L308.2 297.0L309.3 297.3L310.2 297.5L311.4 297.8L312.6 298.0L314.7 298.5L315.0 298.6L315.4 298.7L315.8 298.9L316.0 299.0L316.2 299.1L317.1 299.5L317.3 299.7L317.6 299.8L317.8 300.0L318.1 300.3L318.4 300.6L318.7 300.9L318.9 301.3L319.2 301.6L319.4 301.9L319.6 302.4L319.8 302.8L320.3 303.9L320.8 305.1L321.5 306.7L322.2 308.1L322.5 308.8L322.7 309.2L323.1 309.9L323.7 310.8L325.0 312.7L326.6 315.0L328.2 317.5L329.0 318.7L329.7 320.0L330.2 321.2L330.8 322.5L331.6 324.4L332.2 325.6L332.7 326.3L333.4 327.1L334.3 327.9L335.0 328.4L335.7 328.7L336.3 329.0L336.8 329.1L337.3 329.2L337.8 329.3L338.4 329.3L339.0 329.3L340.6 329.2L342.0 329.0L345.9 328.6L348.6 328.2L350.8 328.0L351.2 328.0L352.5 327.9L353.6 328.0L354.6 328.2L355.5 328.6L356.3 329.0L357.1 329.4L358.4 330.2L360.0 331.2L362.3 332.6L367.9 335.9L368.5 336.3L369.0 336.6L370.2 337.2L370.8 337.3L371.8 337.4L374.3 337.8L375.5 337.9L376.7 338.0L377.9 338.2L378.9 338.3L379.9 338.4L380.6 338.5L381.7 338.6L383.4 338.8L384.9 339.0L385.8 339.1L386.7 339.2L387.4 339.4L388.3 339.8L388.8 340.0L389.5 340.4L390.0 340.7L390.5 341.1L391.0 341.5L391.7 342.2L395.0 345.0L396.5 346.4L397.4 347.2L398.1 347.7L399.3 348.7L400.5 349.8L400.9 350.2L401.0 350.3L401.7 351.0L402.3 351.5L403.4 352.5L404.9 353.8L406.0 354.8L410.0 358.4L411.7 359.8L412.4 360.6L413.0 361.4L413.4 362.0L414.6 363.8L415.3 365.0L416.1 366.1L416.6 366.9L417.0 367.6L417.3 367.9L417.7 368.3L418.1 368.8L419.2 369.8L420.0 370.5L420.4 370.8L420.8 371.1L421.3 371.4L421.8 371.6L422.4 371.8L423.3 372.1L423.8 372.2L424.7 372.3L430.8 373.3L433.4 373.7L434.3 373.9L434.9 374.1L435.5 374.3L435.9 374.5L436.3 374.6L437.5 375.2L439.3 376.1L440.0 376.4L440.7 376.6L441.3 376.8L442.1 377.0L442.6 377.0L443.2 377.1",
    "M443.2 377.1L443.6 377.1L444.1 377.1",
    "M444.1 377.1L445.1 377.2L446.3 377.2L447.6 377.3L448.4 377.4L449.1 377.6L450.3 378.2L453.1 380.4L454.2 381.1L455.1 381.5L456.5 381.9L459.0 382.5L461.6 382.9L463.8 383.1L466.1 382.9L470.0 382.8L470.6 382.8L471.1 383.0L471.6 383.1L472.2 383.4L472.7 383.7L473.0 384.0L474.9 386.3L475.4 386.7L476.0 387.1L477.6 388.3L482.4 391.4",
    "M482.4 391.4L484.2 392.6L485.4 393.3",
    "M485.4 393.3L486.6 394.2L487.0 394.6",
    "M487.0 394.6L487.6 395.3L488.3 396.7L489.9 400.1L490.7 401.1L491.8 402.0L492.7 402.4L493.3 402.5L494.2 402.7L495.4 402.6L497.6 402.4L498.9 402.3L499.3 402.2L500.5 401.7L501.5 401.0L502.1 400.4L505.5 394.7L507.9 391.6",
    "M507.9 391.6L508.5 390.7L508.9 389.8L509.1 389.3L509.1 388.7L509.4 386.2L509.4 385.7L509.5 384.1L509.7 382.8L509.9 381.8L510.0 381.5",
    "M510.0 381.5L511.1 378.7L513.0 376.3L513.7 374.6L513.7 373.7L513.7 372.2L513.3 371.1",
    "M513.3 371.1L512.8 370.0L511.9 368.4L511.2 367.5L510.6 366.7L510.3 366.0",
    "M510.3 366.0L510.0 364.5L510.1 363.2L510.5 361.9L518.7 352.1L522.3 348.1L523.6 346.7L525.2 345.2L528.7 342.3L532.1 339.2L532.8 338.5L533.3 338.0L535.2 336.1L536.1 335.5L537.0 335.0L537.9 334.6L539.0 334.2L540.3 333.9L541.6 333.5L543.6 333.0",
    "M543.6 333.0L545.1 332.6L545.9 332.4L546.4 332.2L546.9 332.1L547.4 331.9L547.7 331.7",
    "M547.7 331.7L548.2 331.4L549.2 330.8",
    "M549.2 330.8L550.4 330.0L551.6 329.3L552.6 328.7L554.6 327.6L555.7 326.9L556.4 326.5L557.6 325.7L557.9 325.4L559.4 324.5L560.6 323.6L561.7 322.9L562.2 322.5L562.8 322.2L563.5 321.9L564.1 321.7L564.8 321.5L565.4 321.4L566.7 321.2L570.1 320.6L571.1 320.4L571.7 320.2L572.3 320.1L573.1 319.9L574.4 319.6L575.9 319.4L577.5 319.2L578.6 319.0L580.2 318.7L582.9 318.2L590.4 316.9L592.1 316.6L593.7 316.4L595.4 316.2L597.6 315.9L599.5 315.8L601.2 315.6L602.0 315.4L605.7 314.7L610.5 313.8L611.8 313.5L613.0 313.2L613.6 313.1L615.9 312.8L617.2 312.6L619.3 312.4L620.9 312.3L622.6 312.4L623.2 312.5L624.5 312.7L625.3 312.7L626.0 312.6L626.4 312.5L626.8 312.5L628.8 312.1L630.7 311.6L632.4 311.3L633.7 310.9L635.2 310.5L636.7 310.2L638.2 309.9L639.9 309.6L641.8 309.3L643.0 309.3",
    "M643.0 309.3L644.3 309.3L645.8 309.5L647.3 309.7L648.6 309.8L649.5 309.7L650.4 309.5L653.4 308.5",
    "M653.4 308.5L658.0 306.9L659.7 306.4L660.9 306.1L662.2 305.8L665.1 305.4L666.8 305.1L667.8 304.9L669.5 304.6L670.5 304.3L671.1 304.2L672.5 304.0L673.9 303.8L675.3 303.7L676.2 303.7L677.4 303.6L678.2 303.5L684.1 302.8L687.2 302.3L694.0 301.4L694.4 301.4L695.0 301.1L696.1 300.9L696.8 300.7L699.6 299.7L700.8 299.3L702.7 298.3L703.9 297.8L706.1 297.0L708.2 296.2L709.0 296.0L710.7 295.5L711.5 295.3L712.8 294.9L713.2 294.7L714.9 293.8L715.6 293.5L716.7 292.9L717.0 292.7L717.4 292.6L717.9 292.2L718.6 291.6L719.4 291.0L720.0 290.6L720.6 290.3L721.1 290.0L721.9 289.6L722.5 289.1L723.1 288.7L723.9 288.0L724.4 287.4L724.9 286.8L725.4 285.9L726.0 284.8L726.3 283.9L726.6 283.0L726.8 282.0L727.0 281.2L727.1 280.2L727.1 279.5L727.0 278.1L726.9 277.4L726.8 276.6L726.7 276.0L726.5 275.1L726.3 274.1L726.2 273.8L725.9 272.4L725.5 271.4L725.1 270.5L724.5 269.5L724.0 268.7L723.4 267.9L722.8 267.3L722.1 266.6L721.7 266.1L721.4 265.8L720.4 264.5L719.2 263.0L718.4 262.0L717.9 261.3L717.4 260.7L706.2 246.9L705.6 246.1L704.8 245.2L702.7 242.8L702.4 242.4L701.8 241.6L701.2 240.7L700.6 239.5L700.3 238.7L700.0 237.5L700.0 236.7L700.0 235.9L700.0 235.3L700.1 234.7L700.5 233.5L700.9 232.1L701.3 231.0L702.3 227.5L703.3 224.8L703.7 223.6L704.2 222.5L704.7 221.4L705.2 220.5L706.1 219.0L707.1 217.3L708.0 215.7L708.8 213.9L709.3 212.6L709.6 211.3L710.1 209.7",
    "M710.1 209.7L710.4 208.6L710.8 206.8L711.1 205.8L711.5 203.9L711.9 202.5",
    "M712.1 202.6L711.8 204.0L711.2 205.9L710.8 207.3",
    "M710.8 207.3L710.0 210.4L709.7 211.5L709.4 212.6L708.9 213.9L708.1 215.7L707.2 217.3L706.2 219.0L705.3 220.5L704.8 221.4L704.3 222.5L703.8 223.6L703.4 224.7L702.4 227.5L701.0 232.2L700.6 233.4L700.3 234.7L700.2 235.3L700.1 235.9L700.1 236.5L700.1 236.7L700.2 237.5L700.2 237.7L700.4 238.6L700.7 239.4L701.1 240.2L701.6 240.8L702.1 241.5L702.7 242.1L704.4 244.3L705.0 245.0L705.7 246.1L706.3 246.8L715.1 257.6L717.6 260.6L718.0 261.2L718.5 261.7L719.5 262.8L720.7 264.3L721.6 265.4L722.4 266.4L722.9 267.2L723.5 267.8L724.1 268.6L724.7 269.4L725.2 270.4L725.6 271.3L726.0 272.3L726.3 273.8L726.3 274.0L726.6 275.1L726.9 276.6",
    "M726.9 276.6L727.1 277.2L727.2 278.0L727.3 279.5L727.3 280.1L727.2 281.2L727.1 281.9L726.9 282.9L726.6 283.7",
    "M726.6 283.7L726.4 284.5L726.1 285.4L725.7 286.5L725.2 287.3L724.7 288.0L724.0 288.8L723.3 289.5L722.6 290.2L721.9 290.8L721.4 291.2L720.8 291.5L720.3 291.8L719.6 292.1L718.7 292.4L717.8 292.8L717.0 293.1",
    "M717.0 293.1L716.1 293.6L714.5 294.5L713.9 294.8L713.4 295.0L713.0 295.2L710.8 296.1L710.0 296.4L709.4 296.6L708.6 296.9L707.7 297.2L706.4 297.7L704.8 298.3L703.6 298.7L701.6 299.2",
    "M701.6 299.2L698.1 300.4L696.2 301.0L694.0 301.5L687.3 302.4L684.1 302.9L678.2 303.6L677.4 303.7L676.2 303.8L675.3 303.9L674.0 304.1L672.5 304.3L671.1 304.5L669.6 304.7L667.8 305.0L666.8 305.2L665.1 305.4L662.2 305.9L660.9 306.2L659.7 306.5L658.0 307.0L653.4 308.6",
    "M653.4 308.6L650.4 309.6L649.5 309.8L648.6 309.9L647.3 309.8L645.8 309.7L644.3 309.4L643.0 309.4",
    "M643.0 309.4L641.8 309.5L639.9 309.8L638.3 310.1L636.7 310.5L635.2 310.8L633.8 311.1L632.3 311.4L630.7 311.8L628.8 312.2L626.9 312.6L626.0 312.7L625.3 312.8L624.5 312.8L623.2 312.6L620.9 312.4L618.9 312.7L617.3 312.9L615.9 313.1L614.4 313.3L613.0 313.5L611.8 313.7L610.6 313.9L605.8 314.8L602.0 315.6L601.1 315.8L599.5 316.0L597.7 316.2L596.4 316.4L596.0 316.4L595.5 316.5L593.8 316.7L592.1 316.8L590.5 317.0L583.0 318.4L578.6 319.2L577.4 319.4L576.3 319.7L576.0 319.7L574.5 320.0L573.2 320.2L572.1 320.4L571.4 320.5L570.2 320.6L567.5 321.1L565.2 321.5L564.5 321.7L563.9 321.9L563.4 322.1L562.9 322.3L562.3 322.6L561.7 323.0L560.6 323.7L559.4 324.5L557.6 325.7L556.4 326.6L555.7 327.0L554.6 327.7L552.9 328.8L551.8 329.5L550.6 330.3L549.4 331.0",
    "M549.4 331.0L548.9 331.4L548.3 331.7L547.7 332.0",
    "M547.7 332.0L547.1 332.2L546.5 332.3L545.9 332.5L545.1 332.7L543.6 333.1",
    "M543.6 333.1L541.7 333.6L540.3 334.0L539.0 334.3L538.0 334.7L537.0 335.1L536.1 335.6L535.3 336.2L533.4 338.1L532.8 338.6L532.2 339.3L528.7 342.4L527.8 343.2L525.3 345.3L523.7 346.8L522.3 348.1L518.8 352.2L510.6 362.0L510.2 363.3L510.1 364.5L510.4 365.9",
    "M510.4 365.9L510.7 366.7L510.8 366.9L511.2 367.5L512.0 368.5L512.8 370.0L513.1 370.5L513.4 371.0",
    "M513.4 371.0L513.8 372.2L513.8 373.7L513.7 374.7L513.1 376.3L511.2 378.8L510.0 381.5",
    "M510.0 381.5L509.7 382.8L509.6 384.1L509.4 385.7L509.4 386.2L509.2 388.7L509.1 389.3L509.0 389.8L508.5 390.7L508.0 391.6",
    "M508.0 391.6L505.8 394.5L502.2 400.5L501.6 401.2L501.1 401.6L500.5 402.0L499.8 402.3L498.8 402.5L497.6 402.7L495.5 402.9L494.1 403.0L493.2 402.8L492.2 402.5L491.4 402.0L490.5 401.3L489.6 400.2L488.1 396.7L487.3 395.4L486.8 394.8",
    "M486.8 394.8L486.4 394.4L485.2 393.5",
    "M485.2 393.5L484.1 392.8L482.2 391.6",
    "M482.2 391.6L481.7 391.2L478.2 388.9L476.9 388.0L475.6 387.2L475.1 386.9L474.6 386.5L474.0 386.0L472.8 384.5L472.2 384.0L471.4 383.5L470.8 383.2L470.1 383.0L469.5 383.0L468.9 383.0L463.8 383.3L461.5 383.2L459.0 382.7L456.3 382.1L454.9 381.7L453.6 380.9L450.3 378.4L449.0 377.7L448.3 377.5L447.6 377.4L446.3 377.3L445.1 377.3L444.1 377.2",
    "M444.1 377.2L443.5 377.2L443.2 377.2",
    "M443.2 377.2L442.1 377.1L441.5 377.1L440.7 377.0L439.9 376.7L439.4 376.5L438.6 376.1L437.4 375.5L435.9 374.7L434.8 374.2L433.5 373.8L424.4 372.6L423.5 372.4L423.1 372.3L422.6 372.1L422.1 371.9L421.7 371.8L421.2 371.5L420.6 371.2L420.1 370.7L418.1 368.9L417.2 368.2L416.8 367.7L416.4 367.2L415.8 366.3L415.0 365.1L414.3 364.0L413.9 363.4L413.8 363.1L412.9 361.5L412.2 360.5L411.6 359.9L409.9 358.4L405.9 354.9L404.7 353.8L402.4 351.8L401.6 351.1L400.8 350.4L400.7 350.4L400.1 349.8L399.1 349.0L398.0 348.0L397.5 347.6L396.9 347.0L396.5 346.6L395.0 345.2L391.7 342.3L390.9 341.5L390.4 341.1L389.8 340.7L389.4 340.4L388.7 340.1L387.7 339.7L386.9 339.5L386.0 339.4L384.8 339.3L383.4 339.1L381.6 339.0L380.6 338.9L379.5 338.7L378.4 338.5L377.5 338.3L377.0 338.3L374.0 338.0L372.7 337.8L370.2 337.4L369.6 337.1L369.0 336.9L368.3 336.5L367.5 336.0L360.0 331.3L358.3 330.3L357.0 329.5L356.3 329.1L355.5 328.7L354.6 328.3L353.6 328.1L352.4 328.0L350.8 328.1L348.8 328.4L345.9 328.7L340.7 329.3L339.0 329.4L338.4 329.4L337.8 329.4L337.3 329.3L336.8 329.2L336.3 329.1L335.6 328.8L335.0 328.5L334.3 328.0L333.3 327.2L332.5 326.3L331.8 325.4L331.2 324.4L330.5 322.7L329.9 321.3L329.3 319.8L328.9 318.8L328.1 317.6L326.5 315.2L324.9 312.8L323.6 310.8L323.0 309.9L322.6 309.3L322.4 308.8L322.1 308.1L321.4 306.7L321.1 306.0L320.7 305.1L319.8 303.1L319.3 302.2L319.1 301.7L318.6 301.1L317.9 300.3L317.7 300.1L317.4 299.9L317.2 299.7L316.9 299.6L316.0 299.1L315.2 298.8L314.6 298.6L310.4 297.7L309.3 297.4L308.1 297.1L306.8 296.8L305.9 296.5L303.9 295.7L303.0 295.5L301.9 295.4L301.0 295.3L298.9 295.4L297.9 295.3L296.6 295.0L295.6 294.7L294.4 294.1L293.5 293.6L291.8 292.7L291.0 292.4L290.5 292.1L289.8 291.7L289.5 291.6L287.9 290.8L287.1 290.4L286.6 290.1L286.2 289.9L285.8 289.7L285.5 289.4L285.1 289.1L284.7 288.7L284.5 288.4L284.2 288.1L283.9 287.7L283.5 286.9L282.7 285.5L282.0 284.2L281.7 283.7L281.0 282.5L280.0 280.5L279.1 279.0L279.0 278.8L278.9 278.6L278.8 278.4L278.6 278.2L278.4 277.9L278.2 277.7L278.1 277.6L278.0 277.5L277.8 277.3L276.7 276.4L274.9 275.0L273.2 273.6L270.8 271.8L268.9 270.4L266.3 268.6L264.4 267.3L263.0 266.2L262.8 266.1L261.7 265.3L261.5 265.2L260.3 264.3L259.2 263.7L258.0 263.1L257.2 262.9L256.3 262.7L255.4 262.6L252.5 262.6L251.8 262.5L251.3 262.5L250.9 262.4L250.5 262.4L247.3 261.5L246.4 261.3L245.8 261.2L244.9 261.1L243.8 261.1L242.7 261.3L241.8 261.5L239.9 262.0L238.3 262.3L235.9 263.0L234.3 263.4L231.5 264.3L228.3 265.6L217.3 269.6L216.0 270.1L211.8 272.2L210.6 272.9L209.3 273.5L207.5 274.2L206.0 274.7L203.6 275.5L202.3 275.8L201.1 276.0L199.1 276.0L194.7 276.1L192.1 276.2L190.1 276.2L188.8 276.2L187.5 276.2L186.0 276.2L184.0 276.6L182.9 276.8L182.4 277.0L181.9 277.3L181.1 277.7L180.7 278.1L180.3 278.5L179.5 279.2L178.9 279.9L177.8 281.3L176.9 282.4L172.6 288.0L172.3 288.5L172.0 289.0L171.7 289.5L171.5 290.0L171.0 291.6L170.6 292.6L170.1 293.5L169.6 294.2L169.0 294.7L168.3 295.3L167.7 295.7L167.3 295.9L166.9 296.0L166.4 296.2L166.0 296.3L165.5 296.4L165.2 296.4L164.8 296.4L163.4 296.4L159.9 296.4L158.2 296.4",
    "M158.2 296.4L157.0 296.4L155.9 296.4L154.6 296.4L153.9 296.5L153.3 296.5L152.6 296.5L151.8 296.5L150.3 296.5L149.0 296.5L148.8 296.5",
    "M148.8 296.5L147.7 296.5L147.0 296.5L146.3 296.5L145.5 296.5L144.1 296.6",
    "M144.1 296.6L140.1 296.9L139.5 297.0L138.9 297.0L138.3 297.1L137.3 297.2L134.9 297.3L132.9 297.5L130.0 297.7L129.4 297.7L128.6 297.8L127.9 297.9L127.3 298.0L126.8 298.1L126.2 298.3L125.7 298.5L125.3 298.8L124.9 299.1L124.6 299.3L124.3 299.6L124.0 299.9L123.7 300.2L122.9 301.3L121.8 303.1L120.6 304.8L119.7 306.1L118.9 307.3L117.1 309.5L116.8 310.0L116.4 310.3",
    "M116.4 310.3L115.2 311.7L113.7 313.2L112.4 314.6",
    "M112.4 314.6L110.7 316.4L108.4 318.8",
    "M108.4 318.8L107.9 319.3L107.4 319.6L107.0 319.9L106.5 320.2L106.0 320.4L105.5 320.6L104.9 320.7L104.4 320.8L103.9 320.9L103.5 320.9L102.9 320.8L102.3 320.8L101.8 320.6L101.1 320.4L100.7 320.2L100.0 319.8L99.4 319.4L99.0 319.0L95.7 315.9L92.8 313.1L91.7 312.2L91.2 311.8L89.4 310.2L88.1 308.9L87.6 308.4L86.5 307.3L85.9 306.7L84.0 304.8L76.2 297.3L73.5 294.8L72.3 293.8L71.5 293.1L70.1 291.7L68.9 290.5L66.5 288.3L65.8 287.7L64.9 286.8L63.0 285.1L62.7 284.8L62.4 284.4L62.1 284.0L61.9 283.7L61.6 283.1L61.5 282.8L61.3 282.3L61.2 281.9L61.1 281.4L61.1 281.0L61.1 280.6L61.1 280.2L61.1 279.7L61.2 279.2L61.3 278.8L61.4 278.4L61.6 277.9L61.9 276.9L63.4 272.7",
    "M63.4 272.7L63.6 272.3L64.3 270.3L64.9 268.6",
    "M64.9 268.6L65.1 267.9L65.2 267.6",
    "M65.2 267.6L65.4 267.2L65.5 266.9L65.7 266.6L65.8 266.2L66.0 265.9L66.2 265.4L66.4 265.0L66.6 264.4L66.8 263.9",
    "M701.6 299.0L703.2 298.5L704.5 298.1",
    "M704.5 298.1L705.0 297.9L706.3 297.4L707.8 296.9L708.6 296.6",
    "M708.6 296.6L709.9 296.1L712.7 295.1L713.5 294.8L714.2 294.5L714.8 294.1L715.4 293.8L716.1 293.4L716.5 293.2L716.9 292.9L717.5 292.6L718.0 292.2L718.7 291.7L719.2 291.3L719.8 291.0L720.3 290.7L720.9 290.4",
    "M720.9 290.4L721.5 290.2L722.2 290.0L723.0 289.8",
    "M723.0 289.8L723.8 289.6L724.7 289.4L725.8 289.1L726.6 288.9L727.5 288.7L728.4 288.5",
    "M728.4 288.5L729.5 288.2L730.6 287.9L731.2 287.7L731.9 287.5L732.5 287.3L733.0 287.0L733.6 286.6L734.1 286.2L734.5 285.9L735.0 285.4L735.6 284.8L736.1 284.1L736.3 283.8L736.4 283.6L737.7 281.7L738.3 280.7L738.6 280.2L740.3 277.4",
    "M740.3 277.4L743.1 273.1L743.6 272.3",
    "M743.6 272.3L743.7 272.2",
    "M743.7 272.2L745.0 270.0L746.0 268.9L746.9 268.2L747.7 267.7L748.4 267.4L749.3 267.1L754.2 265.9L755.1 265.6L756.2 265.2L757.0 264.7L757.7 264.2L758.5 263.5L759.2 262.8L759.8 261.9L760.4 260.9L763.3 253.8L767.1 244.9L770.4 237.1",
    "M770.4 237.1L771.1 235.9L772.1 234.5L773.2 233.4L774.1 232.7L775.7 231.7L777.4 231.1L778.8 230.7L779.9 230.6L781.0 230.5L782.4 230.6L784.0 231.1L786.1 232.0L786.5 232.1L787.4 232.4",
    "M787.4 232.4L793.5 234.9L795.8 235.9",
    "M787.3 232.8L793.3 235.5L795.6 236.5",
    "M787.3 232.8L786.4 232.4L783.4 231.3L782.2 230.9L781.0 230.8L779.7 230.9L778.7 231.1L777.2 231.4L775.9 231.9L774.5 232.8L773.5 233.5L772.4 234.6L771.6 235.6L770.7 237.1L760.7 260.6L760.1 261.8L759.5 262.7L758.9 263.5L758.3 264.1L757.1 265.0L755.9 265.6L754.9 266.0L751.0 267.0L749.2 267.4L748.5 267.6L747.6 268.1L746.8 268.6L746.0 269.3L745.3 270.2L743.6 272.9L740.6 277.6",
    "M740.6 277.6L738.4 280.9L736.4 284.2L736.1 284.7L735.7 285.1L735.2 285.6L734.7 286.0L734.2 286.4L733.7 286.7L733.3 287.0L732.8 287.2L732.4 287.4L732.0 287.6L731.5 287.8L731.0 287.9L730.4 288.1",
    "M730.4 288.1L728.8 288.4L728.0 288.6L726.9 288.9L726.1 289.1L725.6 289.2L725.2 289.4L724.7 289.6L724.1 289.9L722.9 290.3L722.2 290.6L721.6 290.9L721.1 291.1L720.0 291.6L718.8 292.2L718.5 292.3L717.7 292.7L717.0 293.0L716.1 293.5L715.5 293.8L714.8 294.3L714.2 294.6L713.5 294.9L712.8 295.2L711.2 295.9L710.7 296.0L710.4 296.1L709.9 296.3L709.2 296.4L708.6 296.6"
  ],
  "nel": [
    "M444.9 425.5L447.2 425.4L449.7 425.3",
    "M449.7 425.3L452.0 425.0",
    "M452.0 425.0L452.9 424.9L453.9 424.5L454.8 424.3L455.9 423.7L457.2 422.7L459.4 420.5L461.1 418.2L462.7 416.7L465.1 414.3L468.5 410.8L471.3 407.5L475.0 403.5L475.9 402.7L476.7 401.9L477.6 401.3L479.3 400.2L480.2 399.7L480.7 399.3L481.8 398.3L482.9 397.3",
    "M482.9 397.3L483.6 396.7L484.9 395.4L486.2 394.1L487.0 393.3",
    "M487.0 393.3L487.8 392.3L488.9 390.8L489.7 389.7L490.7 388.6L492.9 386.0L494.6 383.9L495.8 382.7L496.6 382.1L497.7 380.9L498.9 379.0L499.4 377.2L499.9 375.1L500.2 373.4L500.1 372.2L499.9 370.9L499.2 369.4L495.2 362.6L495.0 362.0L494.7 361.2L494.6 360.6L494.6 358.9L494.7 358.3L494.8 357.7L495.0 357.0L495.2 356.5L495.6 355.7L496.7 353.8L497.6 352.0L498.8 349.9L500.4 346.8L501.8 344.5L502.4 343.4L502.9 342.7L503.6 341.7L505.0 340.1L507.4 336.9L508.5 335.5L510.2 333.3L511.6 331.4L512.7 330.1L513.3 329.6L514.9 328.0L516.7 326.2L517.8 325.3L519.3 324.0L520.5 322.8L521.9 321.5L522.6 320.8L524.1 319.9L525.0 319.3L525.6 318.8L526.4 318.0L528.2 316.1L528.6 315.7L530.5 313.4L532.1 311.5",
    "M532.1 311.5L534.2 308.7L535.0 307.5L535.8 306.4L537.8 303.8L538.7 302.8L539.9 301.8L540.8 300.9L541.5 300.1L543.0 298.2L543.5 297.4L544.0 296.2L544.8 293.4L545.3 291.2L545.8 289.0L546.8 284.8L547.2 283.3L548.0 280.6L548.2 279.8L548.8 277.3L549.0 276.1L549.1 274.7L549.2 272.5L549.2 270.7L549.2 269.9L549.1 267.9L549.0 266.2L548.9 263.9",
    "M548.9 263.9L549.0 262.8L549.1 261.7L549.5 260.6L549.9 259.7L550.7 257.9L551.6 256.1L552.3 254.7L552.7 254.0L553.1 253.4L553.7 252.7L555.3 250.7L555.8 250.1L556.2 249.7L557.0 248.9L559.9 246.1L563.0 243.3L564.4 242.0L566.6 240.2L569.3 238.1L570.6 236.9L571.8 235.8L573.3 234.4L574.6 233.2L578.2 230.0L578.5 229.6L581.1 227.2L585.9 222.6L588.4 220.2L590.1 218.6L591.0 217.4L591.7 216.5L592.1 215.7L592.5 214.9L593.0 213.9L593.4 212.7L593.6 212.0L593.9 210.4L594.0 208.9L594.0 205.4L594.0 204.1L594.0 203.3L594.1 202.0L594.3 194.8L594.4 191.9L594.6 188.7L594.7 187.9L594.9 186.4L595.1 185.0L595.4 181.8L595.6 179.2L595.7 178.6L595.9 178.0L596.3 176.5L597.0 174.1L597.4 172.8L598.6 169.7L599.5 166.5L599.8 165.6L600.2 164.4L601.1 161.8L601.4 160.9L603.7 156.4L604.0 155.8L605.9 152.2L607.6 149.2L608.7 147.2L610.5 143.8L611.5 142.2L612.6 139.8L613.2 138.7L614.8 135.8",
    "M614.8 135.8L616.0 133.6L617.3 131.2L617.6 130.6L617.9 129.9L618.1 129.2L618.3 128.6L618.4 127.8L618.6 124.7L618.9 123.1L619.3 121.9L619.7 121.1L620.0 120.6L620.7 119.8L621.5 119.0L622.4 118.4L623.4 117.8L624.5 117.5L628.7 116.3",
    "M628.7 116.3L629.6 116.1",
    "M629.6 116.1L630.9 115.7L632.8 115.2L635.3 114.5L636.8 114.4L637.8 114.4L638.8 114.5",
    "M638.8 114.7L637.9 114.6L636.8 114.6L635.2 114.8L632.9 115.5L631.0 116.0L629.6 116.4",
    "M629.6 116.4L628.7 116.6",
    "M628.7 116.6L624.6 117.8L623.6 118.1L622.6 118.6L621.7 119.2L620.9 120.0L620.2 120.8L620.0 121.2L619.6 121.9L619.1 123.1L618.9 124.8L618.5 128.1L618.4 128.6L618.3 129.2L618.0 130.0L617.8 130.5L617.5 131.3L616.2 133.8L615.0 135.9L613.4 138.9L612.3 141.0L611.6 142.2L610.7 143.9L608.8 147.2L607.7 149.3L606.1 152.3L604.1 155.8L603.8 156.4L601.7 161.0L601.4 161.8L600.5 164.4L600.1 165.7L599.8 166.5L598.6 169.8L597.7 172.9L597.4 174.0L596.6 176.6L596.3 177.9L596.1 178.5L595.9 179.4L595.7 181.8L595.2 185.1L595.0 186.5L594.8 187.9L594.7 188.8L594.4 194.8L594.2 204.1L594.2 205.4L594.3 208.9L594.1 210.5L593.9 212.0L593.6 212.8L593.2 214.1L592.8 215.1L592.4 215.8L592.0 216.6L591.3 217.5L590.4 218.7L588.3 220.7L586.1 222.8L581.3 227.4L578.7 229.8L577.6 230.8L574.8 233.4L573.5 234.6L572.0 236.0L570.8 237.1L569.4 238.3L569.2 238.5L566.9 240.5L564.6 242.3L563.2 243.6L560.2 246.3L557.3 249.0L556.6 249.7L556.0 250.4L555.6 250.9L553.9 252.8L553.3 253.6L552.8 254.4L552.6 254.8L551.5 257.0L551.1 257.9L550.2 259.8L549.8 260.7L549.5 261.9L549.3 262.8L549.3 263.9L549.4 266.1L549.5 267.8L549.4 269.9L549.5 270.7L549.5 272.5L549.4 274.7L549.3 276.1L549.1 277.4L548.5 279.9L548.3 280.7L547.6 283.5L547.2 284.7L546.7 287.0L546.2 289.0L545.6 291.3L545.1 293.5L544.3 296.0L544.0 296.9L543.8 297.5L543.2 298.3L541.7 300.3L541.0 301.1L540.2 301.9L539.0 303.1L538.2 303.9L536.4 306.1L535.9 306.9L535.3 307.7L534.4 309.0L532.3 311.7L530.8 313.5L528.8 315.9L528.5 316.2L526.6 318.2L525.2 319.5L524.5 320.0L522.7 321.2L521.7 321.9L520.6 322.9L519.4 324.1L518.1 325.3L516.9 326.4L515.1 328.2L513.5 329.8L512.7 330.5L511.8 331.5L510.5 333.2L508.7 335.6L507.5 337.1L505.2 340.2L503.9 341.9L503.2 342.8L502.6 343.5L502.0 344.6L500.6 347.0L499.0 350.0L497.8 352.2L496.9 353.9L495.9 355.8L495.5 356.6L495.3 357.3L495.2 357.9L495.1 358.7L495.1 359.4L495.2 360.4L495.4 361.4L495.7 362.3L499.6 369.5L500.2 370.6L500.4 371.9L500.4 373.6L500.1 375.7L499.7 377.3L499.1 379.1L497.8 381.0L496.8 382.1L496.0 382.9L494.9 384.1L493.1 386.2L490.9 388.7L489.9 389.9L489.1 390.9L488.1 392.4L487.2 393.5",
    "M487.2 393.5L486.5 394.3L485.1 395.7L483.9 396.9L483.0 397.6",
    "M483.0 397.6L482.1 398.4L481.0 399.5L480.4 399.9L479.5 400.5L478.0 401.4L477.2 401.9L476.3 402.8L475.5 403.5L471.7 407.6L469.0 411.1L466.3 413.7L463.2 416.9L461.7 418.5L459.6 420.7L457.4 422.9L456.1 424.0L454.9 424.6L453.7 425.0L452.8 425.2L452.0 425.2",
    "M452.0 425.2L449.7 425.4",
    "M449.7 425.4L447.2 425.7L444.9 425.8"
  ],
  "ccl": [
    "M529.4 369.8L529.4 368.7L529.4 366.6L529.4 365.9L529.4 365.1L529.2 364.0L528.9 362.0L528.8 361.4L528.7 360.9L528.7 360.3L528.7 359.4L528.9 358.7L529.1 357.9L529.5 357.3L529.9 356.9L530.6 356.0L531.3 355.6L532.0 355.3L534.6 354.2L536.5 353.5L537.7 353.0L542.9 352.0L547.8 350.4L548.9 350.3L552.4 350.1L554.7 349.6L556.7 348.8L559.0 347.8L560.8 346.9L564.0 345.3L571.2 341.9L573.6 340.9L576.1 339.7L579.4 338.0L581.1 337.4L584.9 336.7L587.5 336.1L588.5 335.9L590.0 335.5L591.1 335.1L592.0 334.5L592.6 333.8L592.9 333.4L593.2 332.5L593.4 331.5L593.4 330.3L593.2 324.8L594.0 320.5L593.8 319.2L593.3 316.6L592.9 315.0L592.9 314.9L591.9 310.6L591.2 307.0L590.7 304.6L589.8 299.8L589.8 299.7L588.8 294.5L587.7 289.0L587.3 287.2L586.9 284.7L586.6 282.9L586.0 281.5L585.5 280.4L584.2 277.6L582.6 274.2L580.7 271.4L578.4 269.8L574.7 268.5L572.6 267.6L567.7 265.2L566.0 264.3L561.0 261.7L559.5 260.2L558.5 259.0L558.2 257.9L557.7 256.1L557.4 253.0L557.2 252.6L556.9 252.1L556.1 251.3L555.3 250.7L555.3 250.7L553.7 249.5L552.4 248.8L549.1 247.7L545.3 246.4L544.5 246.1L543.1 246.1L541.0 246.1L539.0 246.5L536.7 247.1L534.0 247.3L533.3 247.4L532.8 247.5L532.3 247.7L529.7 249.1L525.7 251.0L524.2 251.4L522.8 251.6L521.2 251.5L514.9 250.0L512.6 249.2L509.6 248.4L507.4 248.2L504.9 247.8L502.7 247.2L501.0 246.7L500.1 246.5L499.3 246.4L498.4 246.3L497.5 246.2L496.7 246.0L495.9 245.7L494.5 245.1L492.5 244.2L491.8 244.0L490.8 243.9L489.9 244.0L489.0 244.2L488.2 244.5L487.3 245.0L486.6 245.6L486.0 246.4L485.5 247.3L485.2 248.2L485.0 249.2L484.8 251.0L484.5 253.1L484.4 254.2L483.7 259.3L483.7 260.4L483.8 261.3L484.3 265.0L484.7 273.1L484.9 276.0L485.0 278.2L485.0 279.2L484.9 279.8L484.7 280.6L484.2 281.4L483.6 282.2L483.0 282.8L482.1 283.5L481.1 283.8L478.5 284.5L477.6 284.7L476.2 284.8L475.2 284.7L474.0 284.5L472.5 284.2L470.9 284.1L469.5 284.1L466.2 284.1L454.3 284.1L453.0 284.2L451.9 284.5L443.7 287.3L442.8 287.7L442.2 288.1L441.7 288.5L441.2 288.9L440.6 289.6L440.2 290.3L439.9 291.1L439.7 292.1L439.5 293.1L439.2 296.1L438.6 300.6L438.3 302.7L438.0 303.7L437.1 304.9L435.2 306.9L434.3 308.0L430.6 312.4L430.4 312.7L429.5 313.2L429.1 313.4L428.2 313.6L427.1 313.8L424.8 313.7L423.9 313.8L423.1 314.0L422.3 314.4L421.5 314.9L419.2 317.0L418.3 317.9L416.6 319.5L413.8 322.1L413.2 322.7L412.7 323.0L412.0 323.3L411.2 323.5L407.3 323.5L406.6 323.5L406.2 323.6L405.7 323.6L404.8 323.8L404.7 323.9L404.2 324.2L403.4 324.6L402.2 325.4L401.7 325.8L400.5 326.4L400.2 326.5L397.4 327.5L396.7 327.9L395.3 328.7L394.2 329.3L391.5 330.9L390.5 331.6L389.3 332.5L385.4 336.9L384.3 338.9L383.2 340.9L382.5 342.1L381.7 343.6L380.0 348.9L378.8 351.4L376.4 355.0L376.0 355.5L375.2 356.6L373.7 358.2L373.3 358.7L371.4 362.5L371.0 363.2L370.8 364.0L370.6 365.0L370.5 367.2L370.4 369.3L370.1 370.8L369.8 371.6L368.8 372.9L365.9 375.4L364.7 376.9L364.1 378.4L363.8 379.0L363.5 379.7L363.3 380.8L363.2 382.1L363.3 385.1L363.5 386.9L363.8 387.9L365.0 389.8L368.8 395.5L370.3 396.9L372.0 398.3L373.6 399.0L384.8 402.8L388.7 404.1L401.7 408.8L406.0 410.7L408.5 410.9L408.7 410.9L411.5 411.2L412.7 411.5L416.1 413.3L416.9 413.8L418.0 414.2L419.3 414.4L420.8 414.6L423.1 414.8L425.0 415.0L425.7 415.1L426.4 415.2L427.2 415.6L433.7 419.5L434.8 420.0L436.3 420.7L439.3 422.6L441.2 424.1L442.9 425.1L443.4 425.3",
    "M443.4 425.3L444.0 425.4L444.4 425.4",
    "M444.4 425.4L444.9 425.4L447.3 425.5L449.7 425.5L451.3 425.4",
    "M451.3 425.4L452.0 425.3L452.5 425.3L453.5 425.4L454.2 425.3L454.8 425.2L455.6 425.1L456.3 424.8L457.1 424.3L457.8 423.7L458.5 422.9L459.1 421.9L459.8 421.2L461.4 419.6L462.9 417.9L463.7 417.2L465.7 415.5L469.1 412.5L469.8 411.8L470.3 411.4L471.0 411.0L471.5 410.7L471.9 410.5L472.5 410.3L473.0 410.2L473.6 410.0L474.5 409.9L479.3 409.8L481.5 409.7L483.3 409.9L484.7 410.2L485.8 410.5L487.1 410.5",
    "M487.1 410.5L497.3 410.2L497.9 410.1L498.3 410.1L498.5 410.0L500.5 409.4L504.4 408.2",
    "M504.4 408.2L506.2 407.6L506.6 407.5L507.0 407.4L507.3 407.4L507.7 407.3L508.1 407.4L508.5 407.4L508.8 407.5L510.5 408.0L510.9 408.0L511.2 408.1L511.7 408.1L512.2 408.1L512.7 408.0L513.1 407.9L513.6 407.7L514.0 407.4L514.5 407.2L514.9 406.9L515.3 406.5L515.7 406.0L516.2 405.3",
    "M516.2 405.3L516.6 404.7L517.9 402.7L518.2 402.3",
    "M518.2 402.3L518.4 401.9L518.6 401.6",
    "M518.6 401.6L522.0 396.5L523.1 394.8L524.2 393.1L524.9 392.0L525.3 391.3L527.3 388.2L527.8 387.4L528.6 386.0L529.3 384.5L529.6 383.3L529.7 382.7L529.8 382.0L529.9 379.7L529.5 377.7L529.2 375.1L529.2 373.0L529.3 372.0L529.4 369.8",
    "M504.4 408.2L500.5 409.3L498.5 410.1L498.3 410.1L497.9 410.2L497.3 410.2L487.1 410.6",
    "M487.1 410.6L485.8 410.6L484.9 410.6L483.1 410.3L481.6 410.0L479.3 410.1L474.5 410.2L473.6 410.3L473.0 410.4L472.6 410.6L472.1 410.8L471.7 411.0L471.2 411.2L470.7 411.6L470.1 412.1L469.5 412.7L466.0 415.8L464.0 417.5L463.1 418.3L461.7 419.9L460.1 421.5L459.3 422.2L458.6 423.2L458.0 424.0L457.3 424.7L456.9 425.0L456.1 425.4L455.5 425.6L454.7 425.8L453.9 425.9L452.7 425.8L451.9 425.7L451.4 425.7",
    "M451.4 425.7L449.7 425.8L447.3 425.8L444.9 425.7L444.4 425.7",
    "M444.4 425.7L443.9 425.7L443.3 425.6",
    "M443.3 425.6L443.0 425.5L442.6 425.3L441.6 424.8L440.8 424.2L439.2 422.7L437.3 421.5L433.8 419.8L427.2 415.8L426.3 415.5L425.5 415.3L423.1 415.1L419.1 414.7L417.9 414.4L417.1 414.2L415.9 413.6L413.5 412.2L412.8 411.8L412.0 411.6L410.5 411.4L409.2 411.3L408.4 411.3L407.0 411.1L405.9 411.0L401.4 409.0L390.3 405.0L389.7 404.8L388.3 404.3L386.9 404.0L384.7 403.3L382.8 402.6L372.1 399.0L371.1 398.6L369.8 397.7L369.0 396.8L368.4 395.8L366.1 392.1L364.7 390.0L364.0 388.9L363.6 388.0L363.3 387.4L363.2 386.7L363.1 385.4L363.0 382.1L363.1 380.7L363.4 379.5L363.8 378.3L364.5 376.9L365.4 375.5L368.5 372.9L369.3 371.7L369.9 370.6",
    "M369.9 370.6L370.1 369.2L370.1 367.9L370.2 367.2L370.3 365.0L370.5 363.8L370.8 363.1L372.7 359.4L373.0 358.9L373.5 358.2L374.7 356.8L375.4 355.9L376.2 354.7L378.5 351.3L379.1 349.9L379.9 348.3L381.4 343.5L381.9 342.4L382.8 340.8L383.6 339.4L383.9 338.8L384.8 337.3L385.4 336.6L386.3 335.5L389.8 331.8L390.4 331.3L391.3 330.6L393.9 329.1L395.1 328.4L396.9 327.3L397.6 326.7L399.1 325.2L399.9 324.5L400.5 324.2L401.3 323.8L403.1 323.4L405.5 322.9L406.6 322.6L408.4 322.5L410.6 322.5L411.4 322.5L412.7 322.3L414.2 321.5L416.3 319.3L418.1 317.6L420.3 315.5L421.3 314.6L422.1 314.1L422.9 313.8L423.4 313.6L424.2 313.5L425.2 313.5L427.2 313.4L428.2 313.3L429.3 312.9L429.9 312.6L430.4 312.3L430.8 311.9L434.0 307.7L434.7 306.9L436.5 305.2L437.3 304.3L437.8 303.4L438.3 301.3L438.9 296.1L439.3 293.2L439.4 292.2L439.6 291.2L440.1 290.1L440.4 289.5L441.0 288.8L441.6 288.2L442.1 287.9L442.8 287.4L444.0 286.9L451.8 284.3L453.0 284.0L454.3 283.9L466.2 283.9L469.6 283.9L471.6 283.9L473.0 284.0L474.3 284.2L475.4 284.4L476.3 284.4L477.2 284.4L480.4 283.8L481.2 283.5L482.0 283.1L482.8 282.6L483.4 281.9L484.0 281.1L484.4 280.2L484.6 279.5L484.7 278.4L484.7 277.3L484.6 276.0L484.4 274.4L483.9 269.2L483.7 266.2L483.3 264.4L483.1 262.4L483.1 261.5L483.2 260.3L483.5 257.2L484.1 254.1",
    "M484.1 254.1L484.2 253.0L484.4 251.6L484.6 250.2L484.9 248.4L485.1 246.7L485.4 246.0L485.8 245.1L486.5 244.4L487.1 243.8L487.9 243.3L488.9 242.9L489.6 242.7L490.6 242.7L491.5 242.8L492.6 243.1L493.8 243.7L494.8 244.5L495.5 245.1L496.3 245.6L497.2 245.9L497.9 246.0L498.8 246.1L499.8 246.2L502.8 246.9L507.3 247.9L508.2 248.0L509.7 248.2L513.1 249.3L515.0 249.9L518.4 250.8L521.2 251.4L522.8 251.5L524.2 251.3L525.5 250.9L529.7 249.0L532.2 247.6L533.0 247.3L534.0 247.2L534.4 247.2L536.7 247.0L539.3 246.4L541.0 246.0L543.1 246.0L544.6 246.0L545.4 246.3L546.5 246.7L550.2 248.0L552.4 248.7L553.8 249.4L555.4 250.6L556.0 251.1L557.4 252.4L557.6 253.1L557.8 254.3L558.0 256.1L558.2 257.4L558.5 258.3L558.8 259.0L559.7 260.3L561.1 261.6L563.8 263.0L566.5 264.4L567.8 265.0L568.1 265.2L572.7 267.5",
    "M572.7 267.5L574.8 268.3L575.6 268.6L578.6 269.7L580.8 271.3L582.7 274.2L584.6 278.1L585.7 280.4L586.4 281.9L586.7 283.0L587.1 284.8L587.5 287.5L588.5 292.4L589.7 298.7L589.9 299.8L590.4 302.4L591.7 309.5L593.0 314.9L593.5 316.6L594.0 319.2L594.1 319.9L594.1 320.6L593.7 322.7L593.4 324.4L593.4 324.8L593.4 326.1L593.5 330.6L593.5 331.5L593.5 332.0L593.4 332.5L593.2 333.1L593.1 333.3L593.0 333.6L592.9 333.8L592.8 334.0L592.6 334.2L592.4 334.4L592.3 334.6L592.1 334.7L591.6 335.0L591.2 335.2L590.8 335.4L590.4 335.6L589.9 335.7L589.0 336.0L587.6 336.3L587.6 336.3L585.4 336.7L584.6 336.9L582.5 337.3L581.1 337.5L579.6 338.1L578.1 338.9L576.0 339.9L573.7 341.0L573.3 341.2L563.9 345.4L560.8 347.0",
    "M560.8 347.0L559.1 347.9L556.7 348.9L554.4 349.9L552.4 350.3L549.3 350.5L548.4 350.6L543.1 352.3L538.0 353.2L536.7 353.7L534.7 354.5L532.2 355.6L531.5 355.9L530.9 356.3L530.1 357.1L529.8 357.6L529.5 358.0L529.1 358.8L529.0 359.4L528.8 360.2L528.8 360.9L528.8 361.4L528.9 362.1L529.2 364.0L529.4 365.1",
    "M529.4 365.1L529.4 366.6L529.4 368.7L529.4 369.8",
    "M529.4 369.8L529.3 370.3L529.1 370.8L528.4 371.4L527.7 371.8L526.6 371.9L525.6 371.8L525.0 371.7L523.1 371.0L517.6 367.7L511.1 363.2L509.7 362.1L507.6 360.3L506.3 359.3L505.5 358.7L502.2 357.6",
    "M502.2 357.6L501.3 357.3",
    "M501.3 357.3L498.3 356.2L495.8 355.4",
    "M529.4 369.8L529.3 372.0L529.2 373.0L529.2 375.1L529.6 377.7L529.9 379.7L529.8 382.0L529.7 382.7L529.7 383.3L529.3 384.5L528.6 386.1L527.9 387.4L527.4 388.2L525.3 391.3L524.9 392.0L523.1 394.8L522.0 396.5L520.3 399.4L519.0 401.4L518.8 401.7",
    "M518.8 401.7L518.4 402.4",
    "M518.4 402.4L516.8 404.9L516.4 405.5",
    "M516.4 405.5L515.9 406.2L515.6 406.5L515.0 407.1L514.6 407.5L514.1 407.7L513.7 407.9L513.2 408.1L512.7 408.2L512.2 408.3L511.7 408.3L511.2 408.3L510.8 408.2L510.5 408.1L508.8 407.6L508.5 407.5L508.1 407.5L507.7 407.4L507.3 407.4L507.0 407.4L506.6 407.5L506.2 407.6L504.4 408.2",
    "M495.8 355.2L498.4 356.1L500.4 356.8L501.3 357.2",
    "M501.3 357.2L502.3 357.5",
    "M502.3 357.5L504.6 358.3L505.6 358.7L506.3 359.2L507.6 360.3L510.0 362.2L516.1 366.6L517.7 367.6L518.5 368.1L519.2 368.6L523.1 370.9L525.1 371.6L526.5 371.8L527.6 371.7L528.1 371.4L528.9 370.7L529.2 370.3L529.4 369.8"
  ],
  "dtl": [
    "M323.8 190.7L323.5 190.1L323.2 189.6L319.1 181.9L318.6 180.9L318.3 180.5L317.4 179.7L315.7 177.9L312.7 174.1L311.4 170.7L310.7 168.1",
    "M324.1 191.2L323.8 190.7",
    "M324.1 191.2L324.4 192.1L324.8 192.9L324.9 193.2L325.2 194.1L325.2 194.8L325.6 198.7L325.9 201.2L326.0 202.3L326.2 204.4L326.3 205.1L326.6 205.8L327.8 207.5L328.7 208.8L329.6 210.2L330.7 211.9L334.7 218.2L335.6 220.1L335.9 221.2L335.9 221.9L335.8 222.8L335.7 223.2L335.2 224.8L334.8 226.1",
    "M334.8 226.1L334.7 226.6L335.2 231.6L335.3 232.6L335.5 233.9L335.7 235.0L335.9 235.5L337.7 237.9L338.1 238.5L338.5 239.1L339.0 240.4L339.1 241.0L339.5 242.2L340.5 245.8L341.2 252.1L341.6 253.0L343.3 255.4L344.2 256.5L344.6 257.1L345.8 258.2L349.0 260.2L349.9 261.0L350.5 261.6L350.8 262.1L351.3 262.8L352.0 264.6L352.4 266.4L352.8 268.6L353.0 269.3L353.3 270.2L353.6 270.7L353.9 271.3L354.7 272.2L355.1 272.7L355.7 273.5L356.1 273.8L356.8 274.5L357.2 274.8L358.2 275.3L359.9 276.0L362.7 277.2L367.2 279.1L369.2 279.9L371.3 280.7L374.7 281.9L387.9 286.6L395.7 289.3L397.1 289.8L400.0 290.7L402.5 291.1L404.5 291.6L410.2 293.8L411.4 294.9L412.6 296.6L413.7 297.5L415.8 298.8L417.3 299.7L419.8 301.3L422.2 302.5L425.4 304.7L426.9 305.4L429.5 306.0L432.2 306.5L435.5 307.0L436.3 307.1L437.5 307.2L440.4 307.3L443.0 307.6L445.6 308.2L451.9 310.0L455.1 311.7L456.3 312.1L457.7 312.6L461.1 313.1L463.5 313.7L474.2 317.3L475.8 318.2L477.1 319.5L478.5 321.3L480.3 324.0L481.6 325.5L482.2 326.2L482.7 326.7L483.8 327.6L484.8 328.2L487.5 329.2L489.4 329.8L492.6 331.1L494.5 331.8L495.5 332.2L497.6 333.4L499.6 335.5L501.1 337.2L504.7 340.2L505.5 340.9L508.3 343.5L510.0 344.6L511.7 345.6L513.3 346.4",
    "M513.3 346.4L514.3 347.4L514.9 348.4L515.7 349.5L516.1 350.0L517.4 351.4L517.9 351.9",
    "M517.9 351.9L520.3 354.4L522.1 356.5L523.0 357.8L524.3 359.5L524.9 360.0L526.9 361.2L527.8 362.1L528.2 362.8",
    "M528.2 362.8L528.7 363.7L528.9 364.7L529.0 365.6L529.0 366.2L528.9 368.7L528.8 371.9L529.0 375.5L529.3 377.8L529.6 379.6L529.6 381.6L529.5 382.9L529.1 384.1L528.2 386.2L527.6 387.1L527.1 388.1L525.1 391.2L523.9 392.9L522.8 394.6L522.3 395.3L521.2 396.8L520.8 397.1L520.3 397.8L520.1 398.0",
    "M520.1 398.0L518.9 398.7L518.3 398.9L517.5 399.2L516.8 399.1L516.4 399.0L516.1 398.9L515.7 398.8L514.7 398.1L513.0 397.1L512.2 396.5L510.7 395.5L509.8 394.9L509.4 394.5L508.5 393.8L504.3 391.3L502.9 390.5L498.5 387.9L496.1 386.6L494.1 385.4L491.9 383.7",
    "M491.9 383.7L491.5 383.2L491.1 382.7L490.8 382.2L490.6 381.5L490.6 381.0L490.6 380.5L490.7 379.8L491.0 378.6L491.7 376.9L491.8 376.2L491.9 375.5L492.0 374.7L492.1 374.0L492.3 373.4L492.6 372.7L493.3 371.3L494.5 369.3L495.5 367.5L496.3 366.3L496.7 365.7L497.9 364.5L498.5 364.1L500.9 362.3L502.3 361.2L504.0 359.7L507.0 356.0",
    "M507.0 356.0L507.9 355.0L514.4 347.0L514.9 346.3L517.4 342.6L519.4 339.5L522.5 334.6L525.6 329.9L526.3 329.1L527.2 328.2L528.0 327.6L528.5 327.3L529.7 326.8L531.7 325.9L532.4 325.5L534.4 324.6L535.1 324.0L535.8 323.3L536.8 321.6L538.0 319.6L540.6 316.2L541.3 315.5L542.4 314.6L543.5 314.3L550.8 309.8L551.9 309.1L552.9 308.5L554.0 307.8L558.3 305.7L561.8 304.4L562.4 304.0L563.1 303.6L563.8 302.9L564.2 302.4L566.3 299.1L567.0 298.3L567.6 297.8L568.0 297.5L568.5 297.2L569.0 297.0L569.9 296.7L570.9 296.7L572.6 296.8L573.3 297.1L573.9 297.4L575.4 298.1L576.6 298.7L578.3 299.6L579.0 299.9L579.7 300.1L580.6 300.2L581.4 300.1L582.1 300.0L583.0 300.0L583.7 300.0L585.1 300.1L585.9 300.1L586.3 300.1L588.5 299.2L591.0 298.3L592.7 297.6L595.2 296.8L604.4 293.4L607.0 292.3L608.5 291.5L609.7 291.0L611.5 290.0L612.8 289.3L614.6 287.8L618.3 284.6L619.8 283.5L620.5 283.1L621.4 282.7L622.6 282.2L627.8 281.3L630.5 280.8L632.3 279.9L634.9 278.7L635.5 278.5L635.9 278.4L636.7 278.3L637.8 278.3L638.5 278.4L639.0 278.5L639.4 278.7L640.1 278.9L644.9 280.9L647.2 281.9L650.1 283.1L651.0 283.4L651.7 283.5",
    "M651.7 283.5L652.4 283.6L653.9 283.6L654.9 283.5L655.7 283.3L656.9 282.9L664.7 279.5L665.8 279.1L668.0 278.5L671.8 277.8L673.3 277.6L674.6 277.6L676.5 277.7L678.4 277.7L679.8 277.8L686.2 277.2L687.8 277.0L688.9 276.7L690.2 276.0L691.2 275.0L691.7 274.2L691.9 273.7L692.1 273.4L692.2 273.0L692.4 272.3L692.4 271.4L692.3 270.4L691.8 268.8L690.0 264.6L689.6 263.7L689.4 262.8L689.3 262.0L689.3 260.9L689.3 259.8L689.3 257.6L689.3 256.2L689.2 255.2L689.1 254.0L689.0 253.5L688.9 252.7L688.9 251.0L688.9 250.4L689.0 250.0L689.1 249.6L689.2 249.2L689.4 248.7L689.7 248.0L690.4 246.9L691.2 246.1L692.8 244.4L695.3 242.4L697.0 241.2L697.8 240.5L698.9 239.2L699.7 238.4L700.7 237.4L701.5 236.9L702.8 236.3L703.8 236.1L704.9 236.0L707.2 236.2L711.8 236.1L713.1 236.2L719.2 237.0L721.0 237.1L723.9 237.2L725.4 237.3L726.1 237.3L726.9 237.2L727.5 237.1L728.1 236.8L728.8 236.5L729.8 235.8L730.5 235.3L731.2 235.0L731.5 234.9L732.1 234.7L732.7 234.7L733.4 234.6L734.1 234.6L736.5 235.1L737.2 235.3L738.0 235.6L739.3 236.5L740.0 237.2L740.5 238.0L740.6 238.3L741.1 239.5L741.6 241.9L741.9 243.2L742.0 244.0L742.0 244.5L741.9 246.3L741.8 248.5L741.8 250.4L741.6 252.7L741.2 255.0L740.4 257.9L738.4 264.4L737.4 267.6L736.7 269.9L736.5 270.5L735.7 273.2L735.5 274.4L735.5 275.4L735.6 276.0L735.8 276.9L736.3 277.8L736.8 278.5L737.3 279.0",
    "M737.3 279.0L738.8 280.2L738.9 280.3",
    "M738.8 280.5L738.6 280.4L737.1 279.2",
    "M737.1 279.2L736.6 278.8L735.9 277.8L735.6 277.2L735.4 276.4L735.2 275.4L735.2 274.4L735.3 273.5L735.8 271.8L737.1 267.6L738.1 264.4L740.1 257.9L740.9 254.8L741.3 252.7L741.5 251.0L741.6 249.1L741.7 245.9L741.7 244.4L741.7 243.9L741.5 242.8L740.8 239.5L740.5 238.5L740.0 237.6L739.3 236.8L739.0 236.6L738.1 235.9L737.2 235.5L736.5 235.3L734.2 234.9L733.3 234.9L732.0 235.0L731.1 235.3L730.0 236.0L729.5 236.3L728.5 237.0L727.2 237.5L726.1 237.6L725.0 237.6L723.9 237.6L721.0 237.4L717.6 237.2L717.0 237.2L712.9 236.5L711.3 236.4L708.6 236.5L706.0 236.4L704.1 236.4L703.5 236.5L702.8 236.8L702.2 237.0L701.3 237.5L700.0 238.6L699.2 239.5L697.9 240.8L697.1 241.5L695.0 243.0L693.5 244.1L692.7 245.0L690.6 247.2L690.0 248.2L689.4 249.5L689.2 250.6L689.1 251.8L689.6 256.5L689.6 257.5L689.6 259.8L689.5 261.0L689.6 262.4L689.9 263.4L692.3 269.2L692.7 270.8L692.8 271.9L692.5 273.3L692.1 274.2L691.5 275.1L690.8 275.9L690.0 276.4L688.9 277.0L688.1 277.2L679.4 278.0L676.5 277.9L674.6 277.9L673.3 277.9L671.7 278.1L668.1 278.8L665.3 279.7L656.1 283.6L655.0 284.0L653.9 284.2L652.7 284.2L652.2 284.1L651.4 284.0L650.8 283.8L647.1 282.2L644.7 281.2L640.6 279.5L639.7 279.1L638.6 278.7L637.8 278.5L636.9 278.5L635.9 278.6L635.2 278.8L633.9 279.4L632.5 280.2L631.2 280.8L629.9 281.2L627.9 281.5L623.5 282.3L622.4 282.6L621.4 283.0L620.2 283.7L619.5 284.2L618.1 285.2L615.4 287.7L613.4 289.5L612.3 290.1L608.6 291.8L607.1 292.6L604.4 293.7L595.5 297.0L592.8 297.8L590.2 298.8L588.6 299.5L586.3 300.4L585.5 300.7L583.2 301.2L582.1 301.3L580.9 301.1L580.1 300.9L576.6 299.1L575.3 298.4L573.8 297.7L573.1 297.3L572.3 297.1L571.3 296.9L570.4 296.9L569.9 297.0L569.1 297.3L568.5 297.5L568.1 297.7L567.7 298.0L567.0 298.6L566.4 299.2L564.3 302.6L563.2 303.8L562.4 304.3L561.3 304.7L558.1 306.1L553.0 308.7L552.0 309.3L544.1 314.0L543.3 314.4L542.5 314.9L542.0 315.3L541.1 316.0L538.1 319.7L537.5 320.7L536.3 322.8L535.8 323.6L535.2 324.3L534.4 325.0L532.5 325.8L531.8 326.2L528.6 327.6L528.1 327.8L527.3 328.4L526.1 329.5L522.0 335.8L519.8 339.2L517.6 342.7L516.5 344.5L515.5 346.0L515.0 346.7L512.3 350.0L508.2 355.0L507.2 356.1L505.8 357.7L504.3 359.6L503.7 360.3L502.6 361.4L501.2 362.5L498.4 364.5L497.6 365.2L496.9 365.9L495.7 367.7L494.7 369.5L493.6 371.4L492.8 372.8L492.5 373.4L492.3 374.1L492.1 375.6L492.1 376.1L492.0 376.4L491.8 377.2L491.3 378.6L490.9 379.8L490.8 380.7L490.8 381.5L491.0 382.1L491.2 382.5L491.7 383.0L492.3 383.6L493.8 384.9L495.2 385.9L496.2 386.4L498.6 387.7L502.9 390.4L504.1 391.1L505.3 391.8L506.9 392.7L509.2 394.1L509.8 394.7L510.5 395.3L511.3 395.8L512.3 396.4L513.2 396.9L515.7 398.6L516.0 398.7L516.4 398.9L516.7 398.9L517.1 398.9L517.4 398.9L518.1 398.7L518.7 398.6L519.4 398.2L519.8 397.9",
    "M519.8 397.9L521.2 396.7L522.3 395.3L522.7 394.6L523.9 392.9L525.1 391.2L527.1 388.1L527.6 387.1L528.1 386.2L529.1 384.1L529.4 382.8L529.6 381.6L529.6 379.6L529.3 377.8L528.9 375.5L528.8 371.9L528.9 368.7L529.0 366.2L529.0 365.6L528.9 364.7L528.6 363.7L528.1 362.9",
    "M528.1 362.9L527.9 362.5L527.4 361.9L526.8 361.5L524.8 360.2L524.0 359.5L523.1 358.4L521.9 356.7L520.3 354.6L517.8 352.1L515.9 350.2L514.9 348.9L514.2 347.7",
    "M514.2 347.7L513.2 346.6L512.1 346.1L511.6 345.9L510.4 345.3L509.1 344.6L507.8 343.6L505.2 341.2L504.4 340.5L501.7 338.1L500.9 337.5L499.3 335.8L497.3 333.7L495.6 332.6L494.4 332.1L489.8 330.2L486.5 329.2L484.0 328.1L482.6 326.9L482.1 326.4L481.3 325.7L480.0 324.3L478.2 321.5L476.8 319.8L475.6 318.5L474.1 317.7L463.4 313.9L461.1 313.2L458.2 312.8L456.3 312.2L455.2 311.9L454.1 311.4L451.8 310.3L445.7 308.5L442.7 307.9L440.1 307.5L437.4 307.5L436.2 307.4L435.4 307.4L434.1 307.2L430.2 306.5L426.8 305.8L425.2 305.1L422.0 302.9L419.7 301.7L417.0 300.0L415.6 299.1L413.6 297.8L412.2 296.7L411.3 295.4L409.9 294.1L406.6 292.7L404.1 291.8L400.4 291.2L399.8 291.1L398.8 290.8L396.9 290.1L395.6 289.7L388.3 287.1L371.2 281.1L369.0 280.2L367.1 279.5L359.7 276.4L358.4 275.8L356.6 274.8L354.9 273.2L353.3 271.1L352.7 269.4L352.5 268.6L352.0 266.3L351.6 264.7L350.5 262.2L349.9 261.5L349.0 260.6L348.0 260.0L345.6 258.5L344.2 257.3L341.2 253.1L340.9 252.2L340.2 245.9L339.2 242.5L338.7 241.1L338.1 239.3L337.8 238.7L336.7 237.2L335.9 236.2L335.3 235.1L335.1 233.5L334.3 226.6L334.6 225.7L334.9 224.7L335.5 222.2L335.6 220.8L335.2 219.7L333.1 216.1L330.9 212.7L329.4 210.3L327.6 207.7L326.3 206.0L326.0 205.3L325.8 204.4L325.6 201.9L324.9 194.2L324.4 192.5L324.2 192.1L323.9 191.3",
    "M323.9 191.3L323.6 190.8L320.4 184.6L318.2 180.9L317.1 179.7L315.4 178.0L312.5 174.3L311.8 172.4L310.3 167.1"
  ],
  "tel": [
    "M373.2 46.2L374.6 48.7",
    "M374.6 48.7L375.7 51.0",
    "M375.7 51.0L376.2 51.8L377.8 55.2L379.1 57.3L379.8 58.7L380.2 59.9L380.2 61.0L380.0 62.3L379.8 63.0L379.4 63.7L378.4 65.4L377.9 66.5L377.7 67.3L377.7 68.2L377.7 69.0L377.8 69.6",
    "M377.8 69.6L378.1 71.5L378.3 73.3",
    "M378.3 73.3L378.5 75.1",
    "M378.5 75.1L378.5 75.6L378.4 76.6L378.2 77.6L377.9 78.7L377.7 80.2L377.8 81.4L378.0 82.4L378.3 83.5L378.7 84.1L379.5 85.2L380.3 86.0L381.2 86.6L381.7 86.8L382.2 87.1L383.9 87.7L385.3 88.2L388.1 89.4L389.7 89.9L391.2 90.5L392.1 90.9",
    "M392.1 90.9L392.8 91.2L393.4 91.5L394.1 92.1L394.8 92.7L395.8 93.7L397.0 95.4L399.7 99.4L403.6 104.8L403.8 104.9L406.6 108.7L407.0 109.3L407.4 109.8L407.9 110.2L408.4 110.7L410.3 112.3L412.5 114.2L413.9 115.9L414.4 116.5L415.5 117.8L416.3 118.9L416.8 119.6L417.1 120.4L417.3 121.0L417.3 121.8L417.5 122.8L417.6 123.8L417.8 124.6L419.2 128.4L420.4 131.1L420.9 132.1L422.1 133.9L423.2 135.5L425.1 137.9L426.0 139.1L426.5 139.8L427.1 140.4L427.8 140.8L428.7 141.2L429.9 141.6L430.8 141.7L431.7 141.7L433.0 141.8L434.2 141.9L434.9 142.1L435.7 142.5L436.5 143.0L437.3 143.7L437.9 144.5L438.6 145.7L439.4 148.5L440.1 150.4L440.8 152.2L441.4 153.7L442.0 154.8L442.7 155.7L445.9 158.5L449.2 161.8L452.1 163.5L456.2 165.3L468.5 171.5L474.8 174.7L475.9 175.4L476.7 176.1L477.7 177.0L478.6 177.9L480.0 179.2L481.4 180.9L484.0 185.1L484.8 186.5L485.2 188.0L485.3 189.2L485.2 190.4L484.8 194.1L484.5 195.3L484.2 196.1L483.7 196.9L483.2 197.5L481.3 199.2L481.0 199.5L480.5 200.1L480.2 200.7L479.9 201.1L479.9 201.3L479.7 202.0L479.4 202.8L479.2 203.7L479.1 204.4L478.8 205.7L478.6 207.1L478.4 208.2L478.2 209.5L477.0 215.7L476.5 217.0L476.2 217.7L475.9 218.2L475.4 218.7L474.8 219.4L473.7 220.4L472.0 221.9L469.4 224.3L467.8 225.7L466.2 227.0L464.3 228.6L463.6 229.6L463.0 230.5L462.6 231.4L462.5 231.9L462.4 232.4L462.4 233.1L462.4 233.7L462.5 234.2L462.8 235.0L463.4 235.8L464.5 236.9L465.6 237.9L466.1 238.4L467.3 239.1L467.7 239.3L469.3 240.1L470.4 240.7L471.5 241.2L472.3 241.8L473.1 242.6L474.2 243.6L475.4 244.7L475.9 245.3L476.2 245.8L476.5 246.4L477.1 248.1L477.5 248.9L478.0 249.6L479.5 251.4L480.4 252.7L481.3 254.3L482.2 256.6L482.7 257.9L483.0 258.6L483.2 259.4L483.6 261.4L484.1 265.0L484.2 266.6L484.2 268.3L484.3 269.4L484.3 269.9L484.6 271.0L485.0 271.7L485.2 272.2L485.6 272.9L485.9 273.8L486.0 274.9L486.0 276.0L486.1 280.3L486.3 285.1L486.3 287.9L486.1 288.6L485.8 289.5L485.4 290.4L484.9 291.0L484.2 291.7L483.4 292.4L482.5 292.8L481.5 293.1L478.5 293.9L475.8 294.8L466.6 297.6L463.8 298.5L462.5 299.0L461.5 299.5L460.8 300.1L460.1 300.7L459.7 301.4L459.2 302.2L457.2 305.9L456.3 307.7L455.8 309.1L455.5 310.2L455.5 310.8L455.5 311.4L455.6 312.0L455.7 313.1L455.8 313.5L456.0 315.4L456.0 315.9L456.0 316.7L455.7 317.7L455.1 318.9L450.4 325.5L450.1 326.0L449.2 327.8L448.8 328.6L448.4 329.4L448.1 329.8L447.7 330.2L444.9 332.1L444.2 332.6L443.4 333.4L442.9 334.0L442.6 334.6L442.3 335.3L442.0 336.0L441.8 336.8L441.8 337.4L441.8 338.6L441.8 339.8L441.8 341.5L441.9 342.8L442.0 343.8L442.4 344.7L442.9 345.7L443.7 346.7L444.7 347.6L445.5 348.1L446.3 348.5L447.3 348.9L448.5 349.1L449.9 349.0L451.1 348.8L452.3 348.6L454.4 348.2L455.4 347.9L456.2 347.4L457.2 346.7L458.2 345.6L459.0 345.0L460.4 344.3L461.3 344.1L462.5 344.1L463.5 344.2L464.7 344.7L465.5 345.2L466.4 346.1L467.7 347.8L469.6 350.0L471.9 352.5L472.6 353.5L473.0 354.4L473.1 355.0L473.1 355.9L473.0 357.3L472.7 358.6L472.2 360.5L472.0 360.9L472.0 361.4L471.9 362.4L472.0 363.2L472.2 364.4L472.3 365.0L472.9 367.7L472.9 368.4L472.9 368.9L472.8 370.1L472.4 373.7L472.4 374.6L472.4 376.8L472.4 378.6L472.4 380.6L472.5 381.9L472.7 382.8L472.9 383.5L473.2 384.2L473.9 385.0L475.2 386.5L476.5 387.6L477.3 388.2L478.0 388.5L480.1 389.4L481.6 390.2L483.4 391.4",
    "M483.4 391.4L484.5 392.1L486.0 393.1L486.3 393.3L487.5 394.2",
    "M487.5 394.2L488.2 394.5L489.0 394.8L489.5 394.9L490.0 395.0L490.7 395.0L491.4 394.9L493.3 394.5L495.1 394.0L495.7 393.9L496.2 393.8L496.6 393.8L497.2 393.9L498.0 394.0L498.8 394.3L499.5 394.7L500.1 395.2L500.7 395.8L501.3 396.2",
    "M501.3 396.2L501.6 396.5L502.4 397.0L504.3 398.1L506.2 399.4L507.3 400.0L510.5 402.1L512.6 403.5L514.9 404.9L517.8 406.7L519.2 407.6L523.5 410.2L524.0 410.5L524.4 410.6",
    "M524.4 410.6L525.3 410.9L526.3 411.0L527.0 411.0L527.9 410.9L528.9 410.6L530.1 409.9L533.5 407.5L536.2 405.7L536.8 405.2L538.3 404.2L538.8 403.8L539.2 403.3L539.7 402.6L540.6 401.3L541.6 399.8L543.6 396.5",
    "M543.6 396.5L544.6 395.1L545.3 394.0L546.9 391.4L549.6 387.2L550.1 385.6L550.3 383.8L550.0 382.2L549.7 380.9L549.1 379.8L545.3 372.2L543.7 369.0L543.1 367.5L542.9 366.5L542.9 365.5L543.0 364.6L543.2 363.8L543.4 363.1L543.8 362.3L544.4 361.5L545.2 360.9L546.1 360.4L547.3 359.9L548.4 359.7L548.9 359.7L549.9 359.7L552.4 359.8L553.5 359.8L555.1 359.7L556.7 359.6L557.1 359.7L557.5 359.7L557.8 359.7L558.0 359.8L558.3 359.8L559.4 360.1L559.9 360.2L560.4 360.3L560.8 360.3L561.2 360.3L561.6 360.3L562.9 360.0L565.4 359.5L567.0 359.2L568.0 358.9L569.0 358.7L570.8 358.3L572.9 358.1L574.5 357.9",
    "M574.5 357.9L575.7 357.9L576.9 357.9L579.4 358.1L581.7 358.2L583.6 358.4L585.0 358.6L589.8 359.7L590.4 359.8L591.0 359.9L591.6 359.9L592.3 359.8L592.9 359.7L593.5 359.5L599.2 357.6L600.0 357.2L601.0 356.6L601.6 356.3L602.3 356.1L603.4 355.8L604.6 355.6L607.0 355.2L607.9 355.0L608.7 354.7L609.5 354.3L611.5 352.9L612.0 352.7L612.7 352.5",
    "M612.7 352.5L614.3 352.1L615.3 351.8L615.7 351.6L616.2 351.3L617.3 350.5L619.0 349.3L621.7 347.5L623.8 346.0L625.6 344.8L628.0 343.5L630.9 342.2L631.6 342.0L632.4 341.8L633.4 341.6L635.7 341.1L637.3 340.7L640.1 340.0L642.9 339.3L645.0 338.8L645.9 338.6L647.8 338.3L651.0 337.8L652.3 337.5L653.9 337.1L656.5 336.6L657.1 336.5L657.6 336.4L660.3 336.1L661.1 335.9L661.7 335.8L664.6 335.0L665.5 334.8L666.3 334.7L668.5 334.3L669.4 334.1L670.9 333.6L673.3 332.9L674.8 332.4L675.5 332.3L676.0 332.3L676.4 332.3L676.7 332.3L677.3 332.3L678.4 332.4L679.3 332.4L679.8 332.4L680.3 332.4L680.7 332.3L681.2 332.2L681.5 332.1L681.9 332.0L682.4 331.8L682.9 331.5L683.7 331.1L684.1 330.9L684.5 330.7L685.3 330.4L685.8 330.2",
    "M685.8 330.2L687.0 329.8",
    "M687.0 329.8L688.4 329.4L694.2 327.6L696.6 326.9",
    "M696.6 326.9L701.9 325.2",
    "M702.0 325.5L696.7 327.1",
    "M696.7 327.1L694.2 327.9L688.4 329.6L687.0 330.0",
    "M687.0 330.0L685.8 330.3",
    "M685.8 330.3L685.3 330.4L684.5 330.7L684.1 330.9L683.7 331.1L682.9 331.5L682.4 331.8L681.9 332.0L681.5 332.1L681.2 332.2L680.7 332.3L680.3 332.4L679.8 332.4L679.3 332.5L678.4 332.5L677.3 332.4L676.8 332.4L676.5 332.4L676.0 332.5L675.5 332.5L674.9 332.7L673.3 333.2L671.0 333.9L669.4 334.4L668.5 334.6L666.4 334.9L665.5 335.0L664.7 335.2L661.8 336.0L661.2 336.2L660.3 336.3L657.6 336.6L657.1 336.7L656.6 336.8L654.0 337.4L652.3 337.8L651.0 338.0L647.8 338.6L646.0 338.9L645.1 339.1L643.0 339.6L640.2 340.3L637.4 341.0L635.7 341.3L633.4 341.8L632.5 342.0L631.7 342.2L631.0 342.5L626.0 344.9L623.9 346.3L621.8 347.7L619.2 349.5L617.5 350.7L616.3 351.5L615.8 351.8L615.3 352.0L614.4 352.2L612.7 352.6",
    "M612.7 352.6L612.0 352.8L611.5 353.0L609.5 354.3L608.7 354.7L607.9 355.1L607.0 355.3L604.6 355.7L603.4 355.9L602.3 356.1L601.6 356.4L601.1 356.6L600.1 357.3L599.2 357.7L593.5 359.6L592.9 359.7L592.4 359.9L591.7 360.0L591.0 360.0L590.4 359.9L589.8 359.8L585.0 358.6L583.6 358.4L581.8 358.3L579.4 358.1L577.0 358.0L575.8 358.0L574.6 358.1",
    "M574.6 358.1L572.9 358.3L570.8 358.6L569.0 359.0L568.0 359.2L567.0 359.4L565.3 359.6L562.9 360.1L561.5 360.4L561.2 360.4L560.8 360.4L560.4 360.4L559.9 360.3L559.4 360.2L558.3 359.9L558.0 359.9L557.8 359.8L557.5 359.8L557.1 359.7L556.9 359.7L556.7 359.7L555.1 359.8L553.5 359.9L552.0 359.9L550.8 359.9L549.9 359.9L549.0 359.9L547.9 360.0L547.1 360.2L546.1 360.6L545.5 361.0L544.9 361.5L544.3 362.1L543.8 363.0L543.4 363.7L543.3 364.1L543.2 364.4L543.2 364.9L543.1 365.4L543.2 366.2L543.3 366.9L543.4 367.5L543.7 368.2L544.0 369.0L545.5 372.1L546.5 374.3L549.6 379.9L550.0 381.1L550.4 382.3L550.5 383.5L550.5 384.7L550.3 386.1L549.9 387.3L547.2 391.5",
    "M547.2 391.5L544.8 395.2L543.9 396.7",
    "M543.9 396.7L541.8 400.0L540.8 401.5L540.3 402.3L539.8 403.0L539.5 403.5L539.1 403.9L538.5 404.4L537.0 405.5L535.9 406.2L533.7 407.8L529.8 410.5L528.8 410.9L527.9 411.2L527.0 411.3L526.3 411.3L525.1 411.1L524.4 410.8",
    "M524.4 410.8L524.0 410.6L523.5 410.3L519.2 407.6L517.8 406.7L514.9 404.9L512.6 403.5L510.5 402.2L507.2 400.1L506.1 399.4L504.2 398.1L502.4 397.0L501.6 396.5L501.3 396.3L500.7 395.8L500.1 395.2L499.5 394.7L498.8 394.3L498.0 394.0L497.2 393.9L496.6 393.8L496.2 393.8L495.7 393.9L495.1 394.0L493.3 394.5L491.4 395.0L491.0 395.0L490.4 395.1L489.8 395.1L489.3 395.0L488.7 394.9L488.1 394.7L487.4 394.4",
    "M487.4 394.4L486.6 393.8L485.8 393.3L484.3 392.4L483.3 391.7",
    "M483.3 391.7L482.4 391.1L480.7 390.1L478.7 389.1L478.2 388.9L477.6 388.6L476.7 388.0L475.9 387.5L475.0 386.9L474.2 386.3L473.6 385.7L473.0 384.9L472.8 384.4L472.6 384.2L472.5 383.9L472.4 383.6L472.3 383.3L472.2 382.6L472.2 381.6L472.2 381.2L472.2 379.7L472.2 378.6L472.2 377.1L472.2 374.1L472.2 373.4L472.3 372.6L472.6 369.2L472.6 368.3L472.6 367.8L472.4 366.5L472.1 365.0L471.9 363.8L471.7 362.0L471.7 361.2L471.8 360.3L472.3 358.5L472.7 357.4L472.9 356.8L473.0 355.9L472.9 355.4L472.8 354.7L472.6 354.0L472.3 353.5L471.9 352.9L469.7 350.4L467.5 347.9L466.6 346.8L465.7 345.9L465.0 345.3L464.0 344.8L463.0 344.5L462.2 344.5L461.5 344.5L460.6 344.6L459.4 345.1L458.7 345.5L457.0 347.2L456.4 347.6L455.0 348.3L453.4 348.7L452.4 348.9L450.9 349.2L449.6 349.4L448.2 349.3L446.8 349.0L445.5 348.3L444.4 347.6L443.6 346.8L443.0 346.0L442.5 345.2L442.2 344.4L441.9 343.6L441.8 342.8L441.7 341.5L441.7 339.8L441.7 338.6L441.7 337.4L441.7 336.8L441.9 336.0L442.2 335.3L442.4 334.6L442.8 334.0L443.3 333.3L444.1 332.5L444.9 332.0L446.5 330.9L447.1 330.5L447.6 330.2L448.0 329.8L448.4 329.3L448.7 328.6L449.1 327.8L450.3 325.5L451.0 324.3L454.9 318.8L455.4 317.8L455.6 317.1L455.7 316.2L455.7 315.3L455.5 313.5L455.3 311.9L455.2 311.3L455.2 310.9L455.3 310.3L455.4 309.6L455.6 308.9L456.7 306.5L457.9 304.2L459.1 301.9L459.6 301.1L460.0 300.5L460.5 300.0L460.9 299.6L461.7 299.1L462.6 298.6L465.2 297.7L475.7 294.5L479.2 293.4L481.4 292.9L482.5 292.5L483.5 291.9L484.2 291.4L484.5 291.1L485.0 290.5L485.4 289.7L485.6 289.3L485.8 288.8L485.9 288.2L486.0 287.5L486.0 285.0L485.9 280.3",
    "M485.9 280.3L485.8 276.0L485.7 274.7L485.6 273.9L485.3 273.0L485.0 272.3L484.7 271.6L484.4 270.9L484.2 270.1L484.1 269.3L484.0 268.7L484.0 267.4L483.8 265.9L483.1 263.3L482.9 262.4L482.9 261.3L482.9 260.0L482.6 258.1L482.1 256.7L481.3 254.9L480.6 253.3L479.4 251.5L477.9 249.7L477.4 249.0L477.0 248.2L476.4 246.5L476.1 245.9L475.8 245.4L475.2 244.8L474.1 243.7L473.0 242.7L472.2 242.0L471.4 241.4L470.3 240.8L469.3 240.3L467.7 239.4L467.2 239.2L466.1 238.5L465.5 238.0L464.4 237.0L463.3 235.9L462.7 235.1L462.4 234.2L462.2 233.7L462.2 233.0L462.2 232.4L462.3 231.8L462.4 231.3L462.9 230.3L463.4 229.5L464.2 228.5L466.1 226.8L467.7 225.4L469.3 224.0L471.9 221.7L473.6 220.2L474.7 219.2L475.3 218.6L475.7 218.0L476.1 217.6L476.4 216.9L476.9 215.6L478.0 209.4L478.2 208.1L478.4 207.4L478.7 205.6L478.9 204.4L479.1 203.6L479.3 202.7L479.5 201.8L479.7 201.1L479.8 201.0L479.9 200.6L480.3 199.9L480.8 199.3L481.2 199.0L483.1 197.3L483.7 196.6L484.1 195.9L484.3 195.1L484.6 194.0L485.0 190.2L485.1 189.2L485.1 189.1L485.0 187.9L484.6 186.7L483.9 185.1L481.2 181.1L479.8 179.4L478.4 178.0L477.5 177.2L476.5 176.3L475.8 175.6L474.7 174.9L468.4 171.7L456.2 165.5L452.0 163.7L449.1 161.9L445.8 158.6L442.6 155.8L441.9 154.9L441.3 153.8L440.7 152.2L440.0 150.4L439.3 148.5L438.4 145.8L437.7 144.5L437.2 143.8L436.5 143.2L435.6 142.6L434.9 142.3L434.2 142.1L433.0 141.9L430.8 141.9L429.9 141.7L428.7 141.4L427.7 140.9L427.0 140.5L426.4 139.9L425.8 139.2L425.0 138.0L423.1 135.6L422.0 134.0L420.8 132.2L420.2 131.1L419.1 128.4L417.7 124.6L417.5 123.8L417.3 122.7L417.2 121.7L417.1 121.0L416.9 120.4L416.6 119.6L416.2 119.0L415.4 117.9L414.3 116.6L413.8 116.0L412.4 114.3L410.2 112.4L408.3 110.8L407.8 110.3L407.3 109.9L406.9 109.4L406.4 108.8L403.5 105.1L399.8 100.3",
    "M399.8 100.3L399.0 99.3L397.0 96.8L395.2 94.1L394.4 93.0L393.7 92.3L393.0 91.8L392.5 91.5L392.1 91.3L391.3 90.8",
    "M391.3 90.8L390.8 90.6L389.7 90.1L388.0 89.5L384.5 88.3L382.7 87.5L382.1 87.3L381.5 87.0L380.9 86.7L380.4 86.3L379.1 85.2L378.4 84.2L377.9 83.3L377.5 82.2L377.4 81.3L377.3 80.0L377.5 78.4L378.0 76.3L378.0 75.7L378.0 75.1",
    "M378.0 75.1L377.8 73.4",
    "M377.8 73.4L377.5 71.6L377.3 69.6",
    "M377.3 69.6L377.3 69.5L377.2 68.9L377.3 68.3L377.4 67.3L377.6 66.4L378.0 65.5L378.6 64.6L379.4 63.4L379.8 62.2L380.0 60.8L379.9 59.6L379.4 58.3L377.6 55.4L375.8 52.0L375.4 51.1",
    "M375.4 51.1L374.2 48.9",
    "M374.2 48.9L372.9 46.4"
  ],
  "jrl": [
    "M151.8 266.8L149.9 261.9L149.5 260.5L149.3 259.7L149.3 259.2L149.3 258.7L149.4 258.2L149.7 257.5L150.1 257.0L150.5 256.6L151.0 256.2L153.2 254.9L157.5 252.4L157.8 252.2L159.6 251.2L160.2 250.9L160.7 250.7L161.3 250.5L161.8 250.4L162.5 250.3L163.0 250.2L163.5 250.1L164.2 249.8L164.8 249.4L165.1 249.0L165.5 248.5L165.7 248.0L165.9 247.5L166.0 246.9L166.1 245.8L166.1 245.6L166.2 245.3L166.3 245.0L166.4 244.8L166.5 244.4L166.7 244.0L168.3 241.1L168.5 240.6L168.8 240.3L169.1 240.0L169.4 239.7L169.7 239.6L170.2 239.4L170.7 239.4L171.1 239.4L171.5 239.5L172.0 239.8L172.4 240.1L172.8 240.6L173.2 241.1L173.5 241.7L173.8 242.4L174.7 245.2L174.9 245.7L175.1 246.1L175.3 246.4L175.7 246.7L176.0 247.0L177.4 248.0L179.9 249.8L181.5 250.9L182.6 251.7L183.3 252.1L183.9 252.4L184.5 252.7L185.0 252.8L185.3 252.9L186.0 253.0L188.6 253.3L190.0 253.5L193.0 253.8L195.4 254.1L195.9 254.2L196.4 254.3L196.7 254.4L197.1 254.6L197.3 254.8L197.5 255.0",
    "M197.5 255.0L197.7 255.2L198.0 255.5L198.5 256.2L199.3 257.4L199.6 257.8L200.0 258.0L200.4 258.2L200.8 258.2L201.2 258.2L201.6 258.1",
    "M201.6 258.1L202.1 257.8L204.8 256.5L206.4 255.8L207.1 255.5L207.7 255.2L210.0 253.7L211.2 252.7L213.7 251.0L216.2 249.4L221.3 246.0L222.7 244.8L225.4 243.0L226.5 242.3L227.7 241.7L228.9 241.1L230.2 240.5L231.4 240.1L232.0 239.9L232.7 239.8L237.8 239.4L239.3 239.3L240.7 239.2L241.3 239.2L241.9 239.1L242.6 238.9L243.3 238.7L244.4 238.0L245.5 237.1L247.2 235.4L247.8 234.8L248.2 234.4L250.6 232.4L251.5 231.6L251.9 231.3L252.0 231.1L252.1 231.0L252.2 230.7L252.4 230.4L253.4 227.7L253.7 226.8L254.5 224.9L254.9 223.8L255.2 222.9L255.6 221.9L256.0 220.6L256.5 219.2L257.0 217.9L259.0 212.5L262.2 203.7L262.7 202.6L263.3 201.5L263.8 200.8L264.6 200.1L267.8 196.9L268.4 196.4L269.1 195.9L274.3 192.4L275.3 191.8L276.3 191.0",
    "M276.3 191.0L276.4 190.9L277.0 190.5L279.5 188.7L281.5 187.5L283.4 186.2L283.9 186.0L284.3 185.8L285.2 185.4L285.5 185.2L285.8 184.9L286.1 184.7L286.3 184.4L286.5 184.1L286.6 183.8L286.8 183.4L286.9 182.8L286.9 182.3L287.0 181.9L286.9 181.1L286.7 179.2L286.6 177.1L286.5 175.4",
    "M217.1 329.7L216.5 325.6L216.4 325.0L215.7 319.4L215.7 318.5L215.8 318.0L216.8 313.2L216.9 312.6L216.9 311.9L216.8 311.1L215.5 305.3L214.9 303.1L214.1 300.1L213.6 298.0L212.7 294.6L212.4 293.3L212.3 291.6L212.3 289.9L212.4 288.9L212.7 287.5L214.1 282.0L214.1 281.3L213.9 280.8L213.6 280.4L213.3 280.1L212.7 279.8L209.6 279.0L206.5 277.8L206.1 277.5L205.7 277.2L205.3 276.5",
    "M205.3 276.5L204.0 273.0L203.9 272.3L203.7 270.9L203.0 264.1L202.8 263.4L202.6 262.8L201.1 260.7",
    "M201.1 260.7L199.3 257.9L198.4 256.3L197.9 255.6L197.7 255.3L197.4 255.0L197.2 254.9L197.0 254.7L196.6 254.5L196.3 254.4L195.8 254.3L195.4 254.2L193.0 253.9L191.4 253.7L190.0 253.6L188.5 253.4L188.2 253.4L187.5 253.3L187.0 253.2L186.5 253.2L186.0 253.1L185.1 252.9L184.5 252.8L184.3 252.7L184.0 252.6L183.6 252.4L183.3 252.2L182.6 251.8L181.4 251.0L179.8 249.8L177.4 248.1L176.0 247.1L175.6 246.8L175.3 246.4L175.1 246.2L174.8 245.7L174.6 245.3L173.7 242.4L173.4 241.8L173.1 241.1L172.7 240.6L172.3 240.2L171.9 240.0L171.4 239.8L171.0 239.8L170.7 239.8L170.3 239.8L169.8 240.0L169.6 240.1L169.3 240.3L169.1 240.5L168.8 240.9L168.6 241.3L167.0 244.1L166.8 244.5L166.6 244.8L166.5 245.1L166.3 245.8L166.1 246.9L166.0 247.6L165.8 248.1L165.6 248.5L165.2 249.1L164.8 249.4L164.3 249.8L163.6 250.2L163.1 250.3L162.5 250.4L161.8 250.5L161.3 250.6L160.7 250.8L160.2 251.0L159.7 251.3L157.9 252.3L153.2 255.0L151.0 256.3L150.5 256.6L150.1 257.0L149.8 257.6L149.5 258.2L149.4 258.7L149.4 259.2L149.4 259.7L149.6 260.4L150.1 261.8L152.1 266.7",
    "M297.7 317.6L296.3 317.3L295.3 317.0L289.0 315.7L288.5 315.6L288.0 315.4L287.3 314.6L287.2 313.7L287.3 313.0L287.4 312.7",
    "M287.4 312.7L289.1 309.5L289.3 309.1L289.4 308.7L289.5 308.3L289.6 307.9L289.6 303.1L289.5 301.7L289.2 300.5L288.5 297.7L288.2 297.0L288.1 296.6L287.9 296.4L287.8 296.2L287.5 295.9L287.4 295.7L287.3 295.6L287.1 295.4L285.2 293.6L284.7 293.1L284.1 292.4L283.7 291.6L283.5 290.8L283.4 290.1L283.5 289.1L283.5 288.0L283.3 287.5L282.3 285.7L281.2 283.5L280.2 281.4L279.2 279.5L278.8 278.6L278.8 277.8L279.1 276.7L279.7 275.7L282.6 272.2L284.1 270.1L285.3 268.7L287.2 266.2L287.8 264.8L288.0 264.0L287.9 263.2L287.6 262.4L286.8 261.3L285.7 260.5L284.5 260.3L279.5 259.9L278.8 259.8L275.5 259.0L274.8 258.6L274.3 258.2L274.1 257.8L273.9 257.4L273.8 256.9L273.7 256.5L273.7 256.0L273.7 253.1L273.6 252.4L273.5 251.7L273.1 250.3L272.6 248.9L272.0 247.0L271.1 244.0L270.6 242.4L270.4 241.9L270.3 241.4L270.0 240.9L269.7 240.4L269.4 240.1L269.1 239.7L268.1 238.6L267.8 238.3L266.7 237.3L265.6 236.2L263.7 234.2L262.1 232.4L260.0 230.2L258.2 228.4L256.3 226.4L255.8 225.8L255.4 225.2L255.3 224.8L255.2 224.5L255.1 224.1L255.1 223.7L255.1 223.3L255.1 222.9L255.5 222.4L255.6 221.9",
    "M258.2 214.9L257.0 217.9L256.7 219.3L255.6 221.9",
    "M255.4 222.9L255.3 223.2L255.3 223.6L255.2 224.0L255.3 224.4L255.4 224.8L255.5 225.1L255.9 225.7L256.4 226.3L256.7 226.6L260.0 230.1L262.2 232.3L263.9 234.0L265.8 236.0L266.8 237.1L268.2 238.6L269.2 239.6L269.5 240.0L269.8 240.4L270.1 240.9L270.3 241.3L270.6 241.8L270.8 242.4L271.3 243.9L272.3 247.0L272.9 248.8L273.3 250.3L273.8 251.7L273.9 252.4L273.9 253.1L273.9 255.9L273.9 256.4L274.0 256.9L274.1 257.2L274.3 257.6L274.5 257.9L274.9 258.3L275.6 258.7L279.8 259.8L280.7 259.9L284.5 260.2L285.7 260.4L286.9 261.2L287.7 262.3L288.0 263.2L288.1 264.0L287.9 264.8L287.3 266.3L284.9 269.6L282.8 272.3L279.8 275.8L279.2 276.8L278.9 277.9L279.0 278.6L279.3 279.5L280.4 281.6L281.3 283.5L282.4 285.7L283.1 286.9L283.3 287.3L283.6 288.0L283.6 289.1L283.5 290.1L283.6 290.8L283.8 291.6L284.2 292.3L284.9 293.0L285.3 293.5L287.5 295.6L287.8 295.9L288.2 296.3L288.4 296.7L288.6 297.0L288.7 297.2L288.8 297.7L289.4 300.0L289.7 301.0L289.8 301.7L289.9 308.1L289.8 308.6L289.8 308.9L289.7 309.3L289.5 309.6L289.3 310.2L287.7 312.9",
    "M287.7 312.9L287.5 313.2L287.4 313.7L287.5 314.6L288.1 315.4L288.6 315.6L289.0 315.6L295.3 316.9L296.4 317.2L297.7 317.5",
    "M286.8 175.4L286.9 177.1L287.0 179.1L287.1 181.1L287.1 181.9L287.0 182.3L287.0 182.8L286.8 183.4L286.7 183.8L286.5 184.1L286.4 184.4L286.1 184.7L285.9 185.0L285.6 185.2L285.2 185.4L284.4 185.8L283.9 186.1L283.5 186.3L281.5 187.6L279.7 189.0L277.1 190.7L276.5 191.1",
    "M276.5 191.1L276.4 191.2",
    "M276.4 191.2L275.3 191.9L269.2 196.0L268.5 196.5L267.9 197.0L264.6 200.2L264.1 200.9L263.6 201.5L263.0 202.6L262.5 203.8L259.4 212.2L258.6 214.3L257.3 218.0L255.4 222.9L254.6 224.9L253.9 226.7L253.5 227.8L252.7 230.0L252.5 230.6L252.4 230.9L252.3 231.1L252.0 231.5L251.7 231.9L251.3 232.2L250.7 232.7L248.5 234.6L248.0 235.0L246.8 236.0L246.2 236.6L245.6 237.2L244.5 238.1L243.4 238.8L242.7 239.0L242.0 239.2L241.3 239.3L240.7 239.3L239.3 239.4L237.8 239.4L235.2 239.7L234.0 239.8L233.3 239.9L232.7 240.0L231.5 240.4L230.3 240.8L229.0 241.4L227.8 242.0L226.6 242.6L225.6 243.2L222.9 245.1L221.3 246.1L216.3 249.5L213.9 251.3L211.4 253.0L210.0 253.7L207.8 255.2L207.2 255.6L206.5 256.0L205.0 256.8L202.3 258.1",
    "M202.3 258.1L201.8 258.4L201.5 258.8L201.3 259.0L201.2 259.3L201.1 259.6L201.1 260.0L201.2 260.3L201.3 260.6",
    "M201.3 260.6L202.5 262.4L202.8 263.0L203.0 263.5L203.0 264.1L203.8 271.0L203.9 271.6L204.1 272.3L205.6 276.4",
    "M205.6 276.4L206.0 277.0L206.3 277.3L206.7 277.6L209.8 278.8L212.8 279.6L213.5 279.9L213.9 280.2L214.2 280.7L214.4 281.2L214.4 282.1L212.7 289.0L212.5 289.9L212.4 291.3L212.5 293.2L212.8 294.9L213.6 297.6L214.4 300.0L215.2 303.0L215.6 305.1L216.8 310.6L216.9 311.6L217.0 312.5L216.9 313.2L215.9 318.3L215.8 318.8L215.8 319.5L216.2 322.5L216.3 323.4L216.6 324.2L216.6 324.2L216.8 325.1L217.5 329.6"
  ]
};

export const CURRENT_MRT_ROUTES: Record<string, ReadonlyArray<ReadonlyArray<readonly [number, number]>>> = {
  "nsl": [
    [
      [
        533.1,
        413.2
      ],
      [
        515.8,
        404.3
      ],
      [
        509.6,
        386.3
      ],
      [
        511.5,
        368.7
      ],
      [
        498.1,
        356.6
      ],
      [
        483.5,
        353.4
      ],
      [
        469.2,
        345.9
      ],
      [
        482.5,
        327.2
      ],
      [
        493.5,
        311.4
      ],
      [
        501.3,
        286.9
      ],
      [
        499.5,
        269.8
      ],
      [
        502.6,
        247.2
      ],
      [
        505.1,
        208.8
      ],
      [
        495.7,
        184.5
      ],
      [
        471,
        110.6
      ],
      [
        475.1,
        85.8
      ],
      [
        463.9,
        57.1
      ],
      [
        444.3,
        45.1
      ],
      [
        404.7,
        62.6
      ],
      [
        374.6,
        70.2
      ],
      [
        349,
        79.4
      ],
      [
        324,
        94.6
      ],
      [
        293.8,
        152
      ],
      [
        287.4,
        177.1
      ],
      [
        303,
        231.9
      ],
      [
        298.3,
        252.3
      ],
      [
        283,
        285.4
      ]
    ]
  ],
  "ewl": [
    [
      [
        64.5,
        270.4
      ],
      [
        70.3,
        291.5
      ],
      [
        89.7,
        309.9
      ],
      [
        113.7,
        313.1
      ],
      [
        150.3,
        296.3
      ],
      [
        190.1,
        275.9
      ],
      [
        207.4,
        273.9
      ],
      [
        238.3,
        262.1
      ],
      [
        263,
        265.9
      ],
      [
        283.2,
        285.2
      ],
      [
        330.8,
        322.5
      ],
      [
        358.4,
        330.2
      ],
      [
        381.7,
        338.6
      ],
      [
        399.3,
        348.7
      ],
      [
        415.3,
        365
      ],
      [
        437.5,
        375.2
      ],
      [
        459,
        382.5
      ],
      [
        484.2,
        392.6
      ],
      [
        497.6,
        402.4
      ],
      [
        509.4,
        386.2
      ],
      [
        511.9,
        368.4
      ],
      [
        518.7,
        352.1
      ],
      [
        532.8,
        338.5
      ],
      [
        550.4,
        330
      ],
      [
        574.4,
        319.6
      ],
      [
        595.4,
        316.2
      ],
      [
        615.9,
        312.8
      ],
      [
        636.7,
        310.2
      ],
      [
        672.5,
        304
      ],
      [
        706.1,
        297
      ],
      [
        720.4,
        264.5
      ],
      [
        702.7,
        242.8
      ],
      [
        711.9,
        202.5
      ]
    ],
    [
      [
        712.1,
        202.6
      ],
      [
        704.4,
        244.3
      ],
      [
        720.7,
        264.3
      ],
      [
        706.4,
        297.7
      ],
      [
        672.5,
        304.3
      ],
      [
        636.7,
        310.5
      ],
      [
        615.9,
        313.1
      ],
      [
        595.5,
        316.5
      ],
      [
        574.5,
        320
      ],
      [
        550.6,
        330.3
      ],
      [
        532.8,
        338.6
      ],
      [
        518.8,
        352.2
      ],
      [
        512,
        368.5
      ],
      [
        509.4,
        386.2
      ],
      [
        497.6,
        402.7
      ],
      [
        484.1,
        392.8
      ],
      [
        459,
        382.7
      ],
      [
        437.4,
        375.5
      ],
      [
        415,
        365.1
      ],
      [
        399.1,
        349
      ],
      [
        381.6,
        339
      ],
      [
        358.3,
        330.3
      ],
      [
        330.5,
        322.7
      ],
      [
        282.7,
        285.5
      ],
      [
        262.8,
        266.1
      ],
      [
        238.3,
        262.3
      ],
      [
        207.5,
        274.2
      ],
      [
        190.1,
        276.2
      ],
      [
        150.3,
        296.5
      ],
      [
        113.7,
        313.2
      ],
      [
        89.4,
        310.2
      ],
      [
        70.1,
        291.7
      ],
      [
        64.3,
        270.3
      ]
    ],
    [
      [
        706.3,
        297.4
      ],
      [
        738.3,
        280.7
      ],
      [
        793.5,
        234.9
      ]
    ]
  ],
  "nel": [
    [
      [
        447.2,
        425.4
      ],
      [
        484.9,
        395.4
      ],
      [
        492.9,
        386
      ],
      [
        499.4,
        377.2
      ],
      [
        496.7,
        353.8
      ],
      [
        505,
        340.1
      ],
      [
        514.9,
        328
      ],
      [
        530.5,
        313.4
      ],
      [
        545.8,
        289
      ],
      [
        549.2,
        272.5
      ],
      [
        555.3,
        250.7
      ],
      [
        578.5,
        229.6
      ],
      [
        594,
        205.4
      ],
      [
        595.4,
        181.8
      ],
      [
        600.2,
        164.4
      ],
      [
        614.8,
        135.8
      ],
      [
        630.9,
        115.7
      ]
    ]
  ],
  "ccl": [
    [
      [
        525.3,
        391.3
      ],
      [
        516.6,
        404.7
      ],
      [
        500.5,
        409.4
      ],
      [
        479.3,
        409.8
      ],
      [
        465.7,
        415.5
      ],
      [
        447.3,
        425.5
      ],
      [
        423.1,
        414.8
      ],
      [
        408.5,
        410.9
      ],
      [
        384.8,
        402.8
      ],
      [
        365,
        389.8
      ],
      [
        370.5,
        367.2
      ],
      [
        376.4,
        355
      ],
      [
        383.2,
        340.9
      ],
      [
        395.3,
        328.7
      ],
      [
        418.3,
        317.9
      ],
      [
        434.3,
        308
      ],
      [
        484.9,
        276
      ],
      [
        484.5,
        253.1
      ],
      [
        502.7,
        247.2
      ],
      [
        534,
        247.3
      ],
      [
        555.3,
        250.7
      ],
      [
        567.7,
        265.2
      ],
      [
        585.5,
        280.4
      ],
      [
        589.8,
        299.8
      ],
      [
        593.3,
        316.6
      ],
      [
        587.5,
        336.1
      ],
      [
        573.6,
        340.9
      ],
      [
        559,
        347.8
      ],
      [
        534.6,
        354.2
      ],
      [
        529.4,
        368.7
      ]
    ],
    [
      [
        500.5,
        409.3
      ],
      [
        479.3,
        410.1
      ],
      [
        466,
        415.8
      ],
      [
        447.3,
        425.8
      ],
      [
        423.1,
        415.1
      ],
      [
        408.4,
        411.3
      ],
      [
        384.7,
        403.3
      ],
      [
        364.7,
        390
      ],
      [
        370.2,
        367.2
      ],
      [
        376.2,
        354.7
      ],
      [
        382.8,
        340.8
      ],
      [
        395.1,
        328.4
      ],
      [
        418.1,
        317.6
      ],
      [
        434,
        307.7
      ],
      [
        484.6,
        276
      ],
      [
        484.2,
        253
      ],
      [
        502.8,
        246.9
      ],
      [
        534,
        247.2
      ],
      [
        555.4,
        250.6
      ],
      [
        567.8,
        265
      ],
      [
        585.7,
        280.4
      ],
      [
        589.9,
        299.8
      ],
      [
        593.5,
        316.6
      ],
      [
        587.6,
        336.3
      ],
      [
        573.7,
        341
      ],
      [
        559.1,
        347.9
      ],
      [
        534.7,
        354.5
      ],
      [
        529.4,
        368.7
      ],
      [
        517.6,
        367.7
      ],
      [
        507.6,
        360.3
      ],
      [
        498.3,
        356.2
      ]
    ],
    [
      [
        529.4,
        368.7
      ],
      [
        525.3,
        391.3
      ],
      [
        516.8,
        404.9
      ],
      [
        500.5,
        409.3
      ],
      [
        479.3,
        410.1
      ],
      [
        466,
        415.8
      ],
      [
        447.3,
        425.8
      ],
      [
        423.1,
        415.1
      ],
      [
        408.4,
        411.3
      ],
      [
        384.7,
        403.3
      ],
      [
        364.7,
        390
      ],
      [
        370.2,
        367.2
      ],
      [
        376.2,
        354.7
      ],
      [
        382.8,
        340.8
      ],
      [
        395.1,
        328.4
      ],
      [
        418.1,
        317.6
      ],
      [
        434,
        307.7
      ],
      [
        484.6,
        276
      ],
      [
        484.2,
        253
      ],
      [
        502.8,
        246.9
      ],
      [
        534,
        247.2
      ],
      [
        555.4,
        250.6
      ],
      [
        567.8,
        265
      ],
      [
        585.7,
        280.4
      ],
      [
        589.9,
        299.8
      ],
      [
        593.5,
        316.6
      ],
      [
        587.6,
        336.3
      ],
      [
        573.7,
        341
      ],
      [
        559.1,
        347.9
      ],
      [
        534.7,
        354.5
      ]
    ]
  ],
  "dtl": [
    [
      [
        323.8,
        190.7
      ],
      [
        329.6,
        210.2
      ],
      [
        335.2,
        224.8
      ],
      [
        339.1,
        241
      ],
      [
        352.8,
        268.6
      ],
      [
        369.2,
        279.9
      ],
      [
        397.1,
        289.8
      ],
      [
        417.3,
        299.7
      ],
      [
        436.3,
        307.1
      ],
      [
        456.3,
        312.1
      ],
      [
        481.6,
        325.5
      ],
      [
        504.7,
        340.2
      ],
      [
        511.7,
        345.6
      ],
      [
        520.3,
        354.4
      ],
      [
        528.9,
        368.7
      ],
      [
        525.1,
        391.2
      ],
      [
        512.2,
        396.5
      ],
      [
        502.9,
        390.5
      ],
      [
        496.1,
        386.6
      ],
      [
        494.5,
        369.3
      ],
      [
        507,
        356
      ],
      [
        517.4,
        342.6
      ],
      [
        532.4,
        325.5
      ],
      [
        551.9,
        309.1
      ],
      [
        575.4,
        298.1
      ],
      [
        588.5,
        299.2
      ],
      [
        608.5,
        291.5
      ],
      [
        627.8,
        281.3
      ],
      [
        647.2,
        281.9
      ],
      [
        676.5,
        277.7
      ],
      [
        689.3,
        259.8
      ],
      [
        698.9,
        239.2
      ],
      [
        723.9,
        237.2
      ],
      [
        737.4,
        267.6
      ],
      [
        738.8,
        280.2
      ]
    ]
  ],
  "tel": [
    [
      [
        373.2,
        46.2
      ],
      [
        378.1,
        71.5
      ],
      [
        389.7,
        89.9
      ],
      [
        440.1,
        150.4
      ],
      [
        478.6,
        177.9
      ],
      [
        479.2,
        203.7
      ],
      [
        472,
        221.9
      ],
      [
        470.4,
        240.7
      ],
      [
        486,
        276
      ],
      [
        455.8,
        313.5
      ],
      [
        441.8,
        339.8
      ],
      [
        452.3,
        348.6
      ],
      [
        467.7,
        347.8
      ],
      [
        472.3,
        365
      ],
      [
        472.4,
        378.6
      ],
      [
        484.5,
        392.1
      ],
      [
        493.3,
        394.5
      ],
      [
        507.3,
        400
      ],
      [
        517.8,
        406.7
      ],
      [
        543.6,
        396.5
      ],
      [
        555.1,
        359.7
      ],
      [
        581.7,
        358.2
      ],
      [
        604.6,
        355.6
      ],
      [
        621.7,
        347.5
      ],
      [
        642.9,
        339.3
      ],
      [
        670.9,
        333.6
      ],
      [
        696.6,
        326.9
      ]
    ]
  ],
  "jrl": []
};

export const CURRENT_MRT_STATIONS = [
  {
    "x": 64.4,
    "y": 270.4,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 70.2,
    "y": 291.6,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 89.5,
    "y": 310,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 113.7,
    "y": 313.1,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 150.3,
    "y": 296.4,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 190.1,
    "y": 276,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 207.5,
    "y": 274,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 238.3,
    "y": 262.2,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 262.9,
    "y": 266,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 283,
    "y": 285.4,
    "c": "#009645",
    "i": 1
  },
  {
    "x": 330.6,
    "y": 322.6,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 358.3,
    "y": 330.2,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 382.6,
    "y": 340.2,
    "c": "#009645",
    "i": 1
  },
  {
    "x": 399.2,
    "y": 348.8,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 415.2,
    "y": 365,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 437.4,
    "y": 375.4,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 459,
    "y": 382.6,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 484.5,
    "y": 393.5,
    "c": "#009645",
    "i": 1
  },
  {
    "x": 497.6,
    "y": 402.5,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 509.5,
    "y": 386.3,
    "c": "#009645",
    "i": 1
  },
  {
    "x": 511.7,
    "y": 368.6,
    "c": "#009645",
    "i": 1
  },
  {
    "x": 519.5,
    "y": 353.3,
    "c": "#009645",
    "i": 1
  },
  {
    "x": 532.8,
    "y": 338.6,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 550.5,
    "y": 330.1,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 574.5,
    "y": 319.8,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 594.1,
    "y": 316.5,
    "c": "#009645",
    "i": 1
  },
  {
    "x": 615.9,
    "y": 312.9,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 636.7,
    "y": 310.3,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 672.5,
    "y": 304.2,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 706.3,
    "y": 297.4,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 720.5,
    "y": 264.4,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 702.7,
    "y": 242.8,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 712,
    "y": 202.6,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 533,
    "y": 413.1,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 516.8,
    "y": 405.3,
    "c": "#d42e12",
    "i": 1
  },
  {
    "x": 497.7,
    "y": 355.5,
    "c": "#d42e12",
    "i": 1
  },
  {
    "x": 483.5,
    "y": 353.3,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 468.5,
    "y": 346.9,
    "c": "#d42e12",
    "i": 1
  },
  {
    "x": 482,
    "y": 326.4,
    "c": "#d42e12",
    "i": 1
  },
  {
    "x": 493.6,
    "y": 311.4,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 501.4,
    "y": 286.9,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 499.6,
    "y": 269.8,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 502.7,
    "y": 247.1,
    "c": "#d42e12",
    "i": 1
  },
  {
    "x": 505.3,
    "y": 208.7,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 495.8,
    "y": 184.4,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 471.1,
    "y": 110.7,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 475.3,
    "y": 85.8,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 464,
    "y": 57,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 444.2,
    "y": 44.9,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 404.7,
    "y": 62.5,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 376.2,
    "y": 70.8,
    "c": "#d42e12",
    "i": 1
  },
  {
    "x": 349,
    "y": 79.2,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 323.9,
    "y": 94.4,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 293.7,
    "y": 151.9,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 287.3,
    "y": 177.1,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 302.8,
    "y": 231.9,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 298.2,
    "y": 252.2,
    "c": "#d42e12",
    "i": 0
  },
  {
    "x": 525.2,
    "y": 391.2,
    "c": "#fa9e0d",
    "i": 1
  },
  {
    "x": 500.5,
    "y": 409.4,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 479.3,
    "y": 409.9,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 465.9,
    "y": 415.6,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 447.3,
    "y": 425.6,
    "c": "#fa9e0d",
    "i": 1
  },
  {
    "x": 423.1,
    "y": 414.9,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 408.5,
    "y": 411.1,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 384.8,
    "y": 403,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 364.9,
    "y": 389.9,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 370.3,
    "y": 367.2,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 376.3,
    "y": 354.8,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 395.2,
    "y": 328.6,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 418.2,
    "y": 317.7,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 434.9,
    "y": 307.6,
    "c": "#fa9e0d",
    "i": 1
  },
  {
    "x": 485.1,
    "y": 276,
    "c": "#fa9e0d",
    "i": 1
  },
  {
    "x": 484.4,
    "y": 253.1,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 534,
    "y": 247.3,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 555.4,
    "y": 250.7,
    "c": "#fa9e0d",
    "i": 1
  },
  {
    "x": 567.8,
    "y": 265.1,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 585.6,
    "y": 280.4,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 589.4,
    "y": 299.6,
    "c": "#fa9e0d",
    "i": 1
  },
  {
    "x": 587.6,
    "y": 336.2,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 573.6,
    "y": 340.9,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 559,
    "y": 347.8,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 534.6,
    "y": 354.4,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 529.3,
    "y": 368.7,
    "c": "#fa9e0d",
    "i": 1
  },
  {
    "x": 494.6,
    "y": 386.3,
    "c": "#9900aa",
    "i": 1
  },
  {
    "x": 499.6,
    "y": 377.2,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 504.8,
    "y": 340.3,
    "c": "#9900aa",
    "i": 1
  },
  {
    "x": 515,
    "y": 328.1,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 530.7,
    "y": 313.5,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 546,
    "y": 289,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 549.3,
    "y": 272.5,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 578.6,
    "y": 229.7,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 594.1,
    "y": 205.4,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 595.5,
    "y": 181.8,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 600.3,
    "y": 164.4,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 614.9,
    "y": 135.9,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 631,
    "y": 115.8,
    "c": "#9900aa",
    "i": 0
  },
  {
    "x": 704.4,
    "y": 244.3,
    "c": "#009645",
    "i": 0
  },
  {
    "x": 323.7,
    "y": 190.8,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 329.5,
    "y": 210.3,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 335,
    "y": 224.8,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 338.9,
    "y": 241,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 352.7,
    "y": 268.6,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 369.1,
    "y": 280.1,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 397,
    "y": 290,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 417.1,
    "y": 299.9,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 455.9,
    "y": 312.8,
    "c": "#005ec4",
    "i": 1
  },
  {
    "x": 511.6,
    "y": 345.8,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 512.2,
    "y": 396.4,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 502.9,
    "y": 390.4,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 494.6,
    "y": 369.4,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 507.1,
    "y": 356.1,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 517.5,
    "y": 342.6,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 532.5,
    "y": 325.7,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 552,
    "y": 309.2,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 575.3,
    "y": 298.3,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 608.6,
    "y": 291.7,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 627.9,
    "y": 281.4,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 647.2,
    "y": 282.1,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 676.5,
    "y": 277.8,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 689.4,
    "y": 259.8,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 699.1,
    "y": 239.3,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 723.9,
    "y": 237.4,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 737.2,
    "y": 267.6,
    "c": "#005ec4",
    "i": 0
  },
  {
    "x": 738.5,
    "y": 280.6,
    "c": "#005ec4",
    "i": 1
  },
  {
    "x": 373.1,
    "y": 46.3,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 389.7,
    "y": 90,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 440,
    "y": 150.4,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 478.5,
    "y": 178,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 479.1,
    "y": 203.7,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 472,
    "y": 221.8,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 470.4,
    "y": 240.7,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 441.7,
    "y": 339.8,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 452.4,
    "y": 348.7,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 472.2,
    "y": 365,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 472.3,
    "y": 378.6,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 493.3,
    "y": 394.5,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 507.2,
    "y": 400.1,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 543.8,
    "y": 396.6,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 555.1,
    "y": 359.8,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 581.8,
    "y": 358.3,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 604.6,
    "y": 355.7,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 621.8,
    "y": 347.6,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 642.9,
    "y": 339.4,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 670.9,
    "y": 333.8,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 696.7,
    "y": 327,
    "c": "#9D5B25",
    "i": 0
  },
  {
    "x": 517.7,
    "y": 367.7,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 507.6,
    "y": 360.3,
    "c": "#fa9e0d",
    "i": 0
  },
  {
    "x": 793.4,
    "y": 235.2,
    "c": "#009645",
    "i": 0
  }
] as const;
